import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery'
import { DialogService } from '../../dialogs/dialog.service';
import {
  wrapperGetLogoUrlInApp, wrapperGetSiteLanguage,
  wrapperGtag, wrapperFastspring, wrapperGetSiteVersion, wrappergoToMyAccountNow,
  wrapperGetSiteLogo, wrapperGetNativeLogin, wrapperUseDynamicDNSSupport, wrapperRequestNativeLogin,
  wrapperSetServerSessionStorageParams, wrapperupdateUserUI, wrapperRegisterWebhookCallback, wrapperRegisterCloseCallback
} from '../../javascript.js';                                
import { GalleryService } from '../../providers/gallery.service';
import { LoggerService } from '../../providers/logger.service';
import { PublicapiV1Service } from '../../providers/publicapi.v1.service';
import { SignatureService } from '../../providers/signature.service';
import { UserService } from '../../providers/user.service';
import { ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PageComponent implements OnInit, AfterViewInit, OnDestroy {
  isDownloadDropdownOpen: boolean = false;

  page = null;
  clientMode = false;

  scale = 1.0;

  document: any //$routeParams['document'];
  swrp: any // = $routeParams['swrp'];

  MODE_IDLE = 'idle';
  MODE_INSERTING_TEXT = 'insertingText';
  MODE_INSERTING_PEN_START = 'insertingPenStart';
  MODE_INSERTING_PEN = 'insertingPen';
  MODE_INSERTING_MARKER_START = 'insertingMarkerStart';
  MODE_INSERTING_MARKER = 'insertingMarker';
  MODE_INSERTING_SIGNATURE_PEN_START = 'insertingSignaturePenStart';
  MODE_INSERTING_SIGNATURE_PEN = 'insertingSignaturePen';
  MODE_ERASING = 'erasing';
  mode = this.MODE_IDLE;

  UPGRADE_DOWNLOAD_PDF = '0';
  UPGRADE_DOWNLOAD_SEARCHABLE_PDF = '1';
  UPGRADE_USE_ERASER = '2';

  UNDO_ACTION_NONE = 'none';
  UNDO_ACTION_ERASER = 'eraser';
  UNDO_ACTION_CROP = 'crop';
  UNDO_ACTION_GRAYSCALE = 'grayscale';
  UNDO_ACTION_CONTRAST = 'contrast';
  UNDO_ACTION_RCW = 'rcw';
  undo = {};
  undoAction = this.UNDO_ACTION_NONE;

  onSelectedTextLetterSpacingChangeInProgress = false;
  timeOutIsFromLetterSpacing: any;

  lastPenWidth = 0;
  lastMarkerWidth = 0;

  cropAllowed = false;
  cropBackup = undefined;
  cropStyle: any = { display: "none" };
  cropPoints = {};

  selectedMarker = undefined;
  selectedText = undefined;
  selectedPmkOriginalSize = null;
  selectedTextIsNew = false;
  selectedMarkerInkSize: any;
  selectedImgSignature: any;

  lastFontColor = parseInt("0xFF000000");
  lastFontSize = null;
  lastLetterSpacing = null;
  lastFontName = '2';
  lastFontStyle = {
    bold: 0,
    italic: 0
  };

  textLineSpace = null;
  textLineSpaceTxt1 = null;
  textLineSpaceTxt2 = null;
  
  canvasStyle: any = { display: "none" };
  canvasEditorOpen = false;
  newMarkerColor = 0xFF000000;
  newMarkerWidth = 5;
  prevMarkerColor = null;
  prevPenColor = null;
  addPen: number;
  
  selectPointStyle: any = { display: "none", cursor: "crosshair" };
  selectPointActive = false;

  eraserInkWidth = 50;
  eraserActive = false;
  eraserStyle: any = { display: 'none' };
  eraserHideTimeout = null;

  cropActive = false;

  selectedId = "";
  selectedObj = null;
  initZoomToPinchScale = 0;

  pageSize = { width: 0, height: 0 };
  dropStyle = { width: 0, height: 0 };

  progressDialog = undefined;
  showLoader = true;
  pageIsPositioned = false;
  pageIsLoaded = false;
  showMessage = "";
  showPageSelector = false;
  loaderMessage: any;
  message: any;
  prevPage = undefined;
  prevPageUrl = "";
  nextPage = undefined;
  nextPageUrl = "";
  currentPage = "";
  currentPageNo: any;

  editingCancelled = false;
  
  currentCropPoints = [];
  originalBackground = undefined;
  normalizeColor = "rgba(255,255,255,1)";
  backgroundStyle = {}

  // Client parameters
  token: any //$routeParams['token'];
  grayscale: any //$routeParams['grayscale'];
  clientCurrentPage: any //$routeParams['page'];
  clientPageCount: any //$routeParams['pagecount'];
  pageCount = 1;

  // hide download button based on platform version
  showDownButton = true;
  
  signatureDescription = "";
  savedSignatures: any;
  userId: any;

  searchParams = [];
  imageSignatureTag = undefined;
  searchParam: any;

  //ignore = ignore;

  inputHasFocus = false;

  pageScaled = false; // Initial page scale required
  
  previewPDFWindow = null;

  mouseDown = false;
  dragging = false;

  //translations = {};

  pageModified = false;
  pageModifiedElement = false;
  backgroundWasModified = true;
  documentModified = false;
  unsavedChangesTooltipTimer = null;
  hasElapsedEnoughTimeSinceUnsavedTooltipClosureToShowAgain: any;
  elementMoverCursor = document.getElementById('elementMoverCursor');
  elementDeleteButton = document.getElementById('elementDeleteButton');
  elementScalePlusButton = document.getElementById('elementScalePlusButton');
  elementScaleMinusButton = document.getElementById('elementScaleMinusButton');
  elementMoverButtonsContainer = document.getElementById('elementMoverButtonsContainer');
  elementResizer = document.getElementById('elementResizer');

  timer = undefined;
  loadingSignatures = false;
  clientDownloadPDFLink = null;
  downloadFileType: any;
  downloadPDFWithOCR: any;
  previewOnly: any;
  downloadPNGPage: any;
  OCRLangs: any;
  showChooseOCRLangProgress = false;
  showNoOCRLangWarning = false;
  noMoreOCRLanguages = false;
  selectedOCRLanguages = '';
  
  orderReference = "";
  orderCompleted = false;
  showSubscriptionDialog = false;
  showChooseOCRLang = false;
  storeid = -1;
  storehash = '';
  storereason = '';
  showWaitingForSubscription = false;
  showThankYouForSubscribing = false;
  showUpgradeOptions = false;
  updatingSubscriptionInfo = false;
  subscriptionInfo: any;
  upgradeDialogTitle = '';
  upgradeDialogDescription = '';
  upgradeOptions = null;
  currentlyOpenedUpgradeWindowReason = undefined;

  AFTER_SIGNIN_DOWNLOAD_PDF = '1';
  AFTER_SIGNIN_START_SUBSCRIPTION_PURCHASE = '2';
  AFTER_SIGNIN_SHOW_SIGNATURE = '3';
  AFTER_SIGNIN_START_ERASER_TOOL = '4';

  AFTER_ORDER_COMPLETE_DOWNLOAD_PDF = '0';
  AFTER_ORDER_COMPLETE_START_ERASER_TOOL = '1';
  AFTER_ORDER_COMPLETE_DO_NOTHING = '2';

  jumpToPage: any;
  initialBackground: any = undefined;
  mouseDownPoint: any;
  popupClosed: boolean;

  pageModifiedPosition: boolean = false;

  isImageLoaded: boolean = false;

  penMakerPoints = [];

  styleChanged: boolean;

  navbarDiv = document.getElementById("sw-navbar");
  contextualMenuStyle: any;

  @ViewChild(NgbDropdown, { static: true })
  public dropdown: NgbDropdown;

  public reuse(): boolean {
    return false;
  }

  constructor(private translateService: TranslateService,
    private apiV1: PublicapiV1Service,
    private gallery: GalleryService,
    private signature: SignatureService,
    private user: UserService,
    private dialogs: DialogService,
    private ngZone: NgZone,
    private logger: LoggerService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private renderer: Renderer2,
    private el: ElementRef,
    private location: Location,
    private cdref: ChangeDetectorRef) {

    $(document).keydown(event => {
      try {
        // Ignore key presses if modal dialog is opened
        if (this.isModalOpen()) {
          return;
        }

        // Process key presses
        if (event.ctrlKey === true && (event.which === '61' || event.which === '107' || event.which === '173' || event.which === '109' || event.which === '187' || event.which === '189')) {
          event.preventDefault();

          var delta = -1;
          if (event.which === 107 || event.which === 61) delta = 1;

          this.zoom(delta);
        } else if (!this.inputHasFocus && (event.which === 46 || event.which == 8)) { // Delete and Backspace
          this.ngZone.run(() => { this.deleteSelection(); });
        } else if (event.which === 27) { // Escape
          this.ngZone.run(() => {
            this.deselect();
          });
        }
      } catch (e) {
        logger.logInternalError("PAGE: keydown", e.message);
      }
      // 107 Num Key  +
      // 109 Num Key  -
      // 173 Min Key  hyphen/underscor Hey
      // 61 Plus key  +/= key
    });

    $(window).bind('mousewheel DOMMouseScroll', e => {
      try {
        if (e.ctrlKey === true) {
          e.preventDefault();

          // Ignore mousewheel if modal dialog is opened
          if (this.isModalOpen()) {
            return;
          }

          // Process mousewheel
          e = window.event || e; // old IE support
          var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));

          this.zoom(delta);
        }
      } catch (e) {
        logger.logInternalError("PAGE: mosewheel", e.message);
      }
    });
  }

  ngOnInit(): void {
    this.generateCustomDynamicStylesElement();
    wrapperupdateUserUI();
    this.activateStore();

    this.document = this.route.snapshot.params['document'];
    this.swrp =this.route.snapshot.params['swrp'];
    this.token = this.route.snapshot.queryParams['token'];
    this.grayscale = this.route.snapshot.queryParams['grayscale'];
    this.clientCurrentPage = this.route.snapshot.queryParams['page'];
    this.clientPageCount = this.route.snapshot.queryParams['pagecount'];

    if (this.route.snapshot.queryParams['showdlbtn'] != undefined && this.route.snapshot.queryParams['showdlbtn'] == 'no') this.showDownButton = false;

    this.setLogoUrl();
    this.activate();

    this.downloadPDFWithOCR = this.user.getDownloadPDFWithOCR();
    this.previewOnly = this.user.getPreviewPDFOnly();
    this.downloadFileType = this.user.getDownloadFileType();
    this.downloadPNGPage = this.user.getDownloadPNGPage();
  }

  ngAfterViewInit(): void {
    this.elementMoverCursor = document.getElementById('elementMoverCursor');
    this.elementDeleteButton = document.getElementById('elementDeleteButton');
    this.elementScalePlusButton = document.getElementById('elementScalePlusButton');
    this.elementScaleMinusButton = document.getElementById('elementScaleMinusButton');
    this.elementMoverButtonsContainer = document.getElementById('elementMoverButtonsContainer');
    this.elementResizer = document.getElementById('elementResizer');
  }

  generateCustomDynamicStylesElement() {
    const head = document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    style.type = 'text/css';
    style.id = "dynamicStyles"
    head.appendChild(style);
  }

  ignore() {
    // do nothing!
  }

  activate() {
    this.initMouseMoveHandler();

    // First load the current page, then load related data
    // and finally other pages to cache.
    this.loadPage().then(() => {
      if (this.userId) {
        return this.signature.getSignatureList();
      } else {
        return false;
      }
    }).then( async () => {
      if (this.token) {
        const data = await this.apiV1.getDownloadUrl(this.token, 'pdf');
          if (data && data['status'] === 0) {
              this.clientDownloadPDFLink = data['url'];
          }
      }
    }).then(
      () => {
        this.openSignatureDialogIfNeeded();
        this.openSubscriptionPurchaseIfNeeded();
        this.openStartDownloadIfNeeded();
        this.startEraserToolIfNeeded();
        this.user.setOpenPopupAfterLogin(null);   // Check for popups only once
      }
    ).then( ()  => {
      if (this.token !== undefined && this.token !== '') {
        this.gallery.initClientCache(this.document, this.token, this.grayscale, this.clientCurrentPage);
      } else {
        this.gallery.initCache(this.document, this.currentPageNo);
      }
    });

    this.loadPageMoves();
    this.readSearchParameters();
    this.setupSignatureTag();

    window.logoutHandler = () => {
      this.ngZone.run(() => {
        this.windowLogoutHandler(undefined);
      });
    };
    window.loginHandler = () => {
      this.ngZone.run(() => {
        this.windowLoginHandler();
      });
    };
    window.goToMyAccountHandler = () => {
      this.ngZone.run(() => {
        this.windowGoToMyAccountHandler(undefined);
      });
    };
    //window.goToUpgrade = () => { this.windowGoToUpgradeHandler() };

    this.startUnsavedChangesTooltipTimer();
    this.updateHasElapsedEnoughTimeSinceUnsavedTooltipClosureToShowAgain();
    this.setUpgradeHandler();
  }

  setUpgradeHandler(onDestroy: boolean = false) {
    try {
      if (onDestroy) {
        if (document.body.classList.contains('upgrade-handler-set') == true) {
          document.body.classList.remove('upgrade-handler-set');
        }
        return;
      }

      var handler = window.goToUpgrade = () => {
        this.ngZone.run(() => {
          this.windowGoToUpgradeHandler()
        });
      };
      if (handler == undefined) {
        if (document.body.classList.contains('upgrade-handler-set') == true) {
          document.body.classList.remove('upgrade-handler-set');
        }
      } else {
        if (document.body.classList.contains('upgrade-handler-set') == false) {
          document.body.classList.add('upgrade-handler-set');
        }
      }
    } catch (e) {
      this.logger.write2log("setUpgradeHandler", "Could not find set upgrade handler.", "W");
    }

  }

  activateStore() {
    // register store callbacks
    this.registerCallbacks(true);
  }

  openSignatureDialogIfNeeded() {
    var openPopup = this.user.getOpenPopupAfterLogin(this.AFTER_SIGNIN_SHOW_SIGNATURE);
    if (openPopup && this.userId) {
      this.timer = setTimeout(
        () => {
          this.timer = undefined;
          this.showSignatureDropDownAndLoadSignatures();
        },
        500);
    }
  }

  openSubscriptionPurchaseIfNeeded() {
    var openPopup = this.user.getOpenPopupAfterLogin(this.AFTER_SIGNIN_START_SUBSCRIPTION_PURCHASE);
    if (openPopup) {
      this.timer = setTimeout(
        () => {
          this.timer = undefined;
          this.checkSubscriptionAndStartPurchaseOfSubscriptionOrDownload('pdf');
        },
        500);
    }
  }

  openStartDownloadIfNeeded() {
    var openPopup = this.user.getOpenPopupAfterLogin(this.AFTER_SIGNIN_DOWNLOAD_PDF);
    if (openPopup) {
      this.timer = setTimeout(
        () => {
          this.timer = undefined;
          this.checkSubscriptionAndDownload();
        },
        500);
    }
  }

  startEraserToolIfNeeded() {
    var openPopup = this.user.getOpenPopupAfterLogin(this.AFTER_SIGNIN_START_ERASER_TOOL);
    if (openPopup) {
      this.timer = setTimeout(
        () => {
          this.timer = undefined;
          this.openEraser(true);
        },
        500);
    }
  }

  c(dontStopEditing) {

    //$scope.$apply();
    this.ngZone.run(() => { });

    if (dontStopEditing != true) {
      this.stopEditingCurrentElement();
      setTimeout(() => { this.windowLogoutHandler(true) }, 0);
      return;
    }

    if (this.pageModified) {
      this.save().then(() => {
        this.user.logout().then(() => {
          window.location.reload();
        });
      });
    } else {
      this.user.logout().then(() => {
        window.location.reload();
      });
    }
  }


  windowLogoutHandler(dontStopEditing: boolean) {

    //$scope.$apply();
    this.ngZone.run(() => { });

    if (dontStopEditing != true) {
      this.stopEditingCurrentElement();
      setTimeout(() => { this.windowLogoutHandler(true) }, 0);
      return;
    }

    if (this.pageModified) {
      this.save().then(() => {
        this.user.logout().then(() => {
          window.location.reload();
        });
      });
    } else {
      this.user.logout().then(() => {
        window.location.reload();
      });
    }
  }

  windowLoginHandler() {
    this.doLogin(false, true);
  }

  windowGoToMyAccountHandler(dontStopEditing) {

    //$scope.$apply();
    this.ngZone.run(() => { });

    if (dontStopEditing != true) {
      this.addPenMarker(this.penMakerPoints, this.mode);
      this.stopEditingCurrentElement();
      setTimeout(() => { this.windowGoToMyAccountHandler(true) }, 0);
      return;
    }

    if (this.pageModified) {
      this.save().then(() => {
        wrappergoToMyAccountNow();
      });
    } else {
      wrappergoToMyAccountNow();
    }
  }

  windowGoToUpgradeHandler() {
    try {
      this.doShowUpgradeOptions(undefined);
    } catch (e) {
      this.logger.write2log("windowGoToUpgradeHandler", "Could not start upgrade window.", "W");
    }
  }

  ngOnDestroy(): void {
    this.initMouseMoveHandler(false);
    window.logoutHandler = undefined;
    window.loginHandler = undefined;
    this.registerCallbacks(false);
    this.clearEraserHideTimeout();
    this.setUpgradeHandler(true);
    this.clearUnsavedChangesTooltipTimer();
    if (this.timeOutIsFromLetterSpacing) clearTimeout(this.timeOutIsFromLetterSpacing);
  }


  clearEraserHideTimeout(): void {
    if (this.eraserHideTimeout !== null) {
      clearTimeout(this.eraserHideTimeout);
      this.eraserHideTimeout = null;
    }
  }

  // =============
  // Load the page from the server
  // =============

  /**
   * Finds and initializes image signature input tag.
   */
  setupSignatureTag() {
    try {
      this.imageSignatureTag = document.getElementById("imageSignature");
      if (this.imageSignatureTag) {
        this.imageSignatureTag.addEventListener('change', this.addImageSignature, false);
      }
      else
        this.logger.write2log("PageController", "Could not find imageSignatureTag", "W");
    } catch (e) {
      this.logger.write2log("PageController", "Could not find imageSignatureTag", "W");
    }
  }

  /**
   * Reads the search parameters and initializes required variables.
   * Used when passing parameters from client aplications.
   */
  readSearchParameters() {
    if (this.token !== undefined) {
      this.searchParams.push("token=" + this.token);
      this.clientMode = true;
      this.showDownButton = false;
      try {
        if (this.clientCurrentPage !== undefined) {
          this.searchParams.push("page=" + this.clientCurrentPage);
          this.clientCurrentPage = parseInt(this.clientCurrentPage);
        }
        if (this.clientPageCount !== undefined) {
          this.searchParams.push("pagecount=" + this.clientPageCount);
          this.clientPageCount = parseInt(this.clientPageCount);
        }
      }
      catch (e) {
        this.logger.logInternalError('', e);
      }
    }
    if (this.grayscale !== undefined) {
      this.searchParams.push("grayscale=" + this.grayscale);
    }
    this.searchParam = this.searchParams.length == 0 ? "" : this.searchParams.join("&");
  }
  /**
         * Scales the background image to fit the page div. Called after the image is loaded to the tag.
         */
  onLoad() {
    if (this.pageScaled) return;
    this.isImageLoaded = false;

    try {
      var bg = document.getElementById('background');
      var pc = document.getElementById('pagePlaceholder');

      var iWidth = bg.offsetWidth + 200; //bg['width'] + 200;    // 200 = margin (see css)
      var iHeight = bg.offsetHeight; //bg['height'];
      var cWidth = pc.clientWidth;
      if (cWidth > 1000)
        cWidth = 1000;  // Max allowed width: 1170;

      this.pageSize = { width: bg.offsetWidth, height: bg.offsetHeight }; // { width: bg['width'], height: bg['height'] };
      this.dropStyle = { width: bg.offsetWidth, height: bg.offsetHeight }; // { width: bg['width'], height: bg['height'] };

      var scale = (cWidth - 20) / iWidth;

      this.zoomToScale(scale);
      this.horizontallyPositionPage();

      this.pageScaled = true;
      this.isImageLoaded = true;
    } catch (e) {
      this.logger.logInternalError("PAGE: OnLoad", e.message);
    }
  }
  /**
   * Handles screen resize event.
   */
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.horizontallyPositionPage();
  }

  /**
   * Horizontally position page to be in the center of the container
   */
  horizontallyPositionPage() {
    var pageContainer = document.getElementById('pagePlaceholder');
    var elementMover = document.getElementById('elementMover');
    var page = document.getElementById('page');
    var pageStyle = window.getComputedStyle(page);

    var pageW = (page.scrollWidth * this.scale);
    var pageContainerW = pageContainer.offsetWidth;

    var left = Math.max(0, Math.floor((pageContainerW - pageW) / 2.0)) + 'px';
    page.style.left = left;
    elementMover.style.left = left;
    elementMover.style.top = '25px';    // See css -- .page.top = 25px;

    this.pageIsPositioned = true;
    this.hideLoaderWithDelay();
  }

  hideLoaderWithDelay() {
    this.hideLoader();
  }

  hideLoader() {
    this.showLoader = false;
  }

  showLoaderFunction() {
    this.showLoader = true;
  }

  /*
         * Saves the current page.
         */
  async save(hideLoaderAfterComplete: any = undefined, downloadFileAfterSave: any = undefined) {

    try {
      var i;
      this.page.elements = [];

      var pageContainsBackground = this.backgroundWasModified;
      this.page.elements.push(this.page.background);

      // TODO: make sure that __type is the first key in page.elements objects!
      for (i = 0; i < this.page.texts.length; i++) {
        this.page.texts[i].x = Math.ceil(this.page.texts[i].x);
        this.page.texts[i].y = Math.ceil(this.page.texts[i].y);
        this.page.elements.push(this.page.texts[i]);
      }
      for (i = 0; i < this.page.markers.length; i++) {
        this.page.markers[i].bezierInts = this.page.markers[i].bezierInts.map(p => { return Math.ceil(p); });
        this.page.markers[i].x = Math.ceil(this.page.markers[i].x);
        this.page.markers[i].y = Math.ceil(this.page.markers[i].y);
        this.page.elements.push(this.page.markers[i]);
      }
      if (this.page.imageSignatures !== undefined) {
        for (i = 0; i < this.page.imageSignatures.length; i++) {
          this.page.elements.push(this.page.imageSignatures[i]);
        }
      }
      if (this.page.filters !== undefined) {
        for (i = 0; i < this.page.filters.length; i++) {
          this.page.elements.push(this.page.filters[i]);
        }
      }

      this.showLoaderWithMessage(this.translateService.instant('SavingFile'));

      const data = await this.gallery.savePage(this.document, this.swrp, this.page, this.token, this.userId, pageContainsBackground, this.clientMode);
        if (hideLoaderAfterComplete && !downloadFileAfterSave)
            this.hideLoaderWithMessage();
        if (data === undefined)
            this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorSavingFile'));
        else if (data['status'] === 0) {
            this.pageModified = false;
            this.backgroundWasModified = false;
            if (downloadFileAfterSave) {

                if (this.user.getDownloadPDFWithOCR() === true && this.userId)
                    this.showLoaderWithMessage(this.translateService.instant('PerformingOCRAndSavingFile'));

                else
                    this.showLoaderWithMessage(this.translateService.instant('SavingFile'));

                this.logger.write2log("save", "[" + this.swrp + "][" + this.userId + "] Got download link: " + downloadFileAfterSave, "P");

              var config = {
                method: "GET",
                url: downloadFileAfterSave,
                options: {
                  timeout: 30 * 60 * 1000
                }
              };

              this.logger.write2log('gallery.savePage', 'Setting timeout to ' + (30 * 60 * 1000), 'P');
                var promise = new Promise((resolve, reject) => {
                  this.http.get(downloadFileAfterSave).subscribe({
                    next: (data: any) => {
                      try {
                        if (data.status === 0) {
                          this.waitForPreparationToCompleteThenDownload(0, data.preparationId, downloadFileAfterSave, 3);
                        } else {
                          this.logger.write2log("savePage.data", "Got invalid response " + (data ? data.status : "NULL"), "E");
                          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorSavingFile'));
                          this.hideLoaderWithMessage();
                        }
                      } catch (ex) {
                        this.logger.logInternalError("savePage.data", ex.message);
                        this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorSavingFile'));
                        this.hideLoaderWithMessage();
                      }
                    },
                    error: (err: any) => {
                      if (err.status === 504) {
                        // Timeout
                        this.logger.write2log('gallery.savePage.ERROR', 'Got response code ' + err.status, 'E');
                        this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotDownloadFileTooBig'));
                      } else {
                        // Unexpected error
                        this.logger.write2log('gallery.savePage.ERROR', 'Got response code ' + err.status, 'E');
                        this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorSavingFile'));
                      }
                      this.hideLoaderWithMessage();
                    }
                  });
                });
              return promise;

          }
          this.hideLoaderWithMessage();
            return data;
        }
        else if (data['status'] === 1) {
            this.logger.write2log("save", "[" + this.swrp + "][" + this.userId + "] -- Downloading filed, session expired.", "E");
            this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('SessionExpired') /*, () { $location.path("/"); }*/);
            this.hideLoaderWithMessage();
        }
        else {
            this.logger.write2log("save", "[" + this.swrp + "][" + this.userId + "] -- Downloading filed, error saving file.", "E");
            this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorSavingFile'));
            this.hideLoaderWithMessage();
      }
      this.hideLoaderWithMessage();
        return undefined;
    } catch (e) {
      this.logger.logInternalError("PAGE: save", e.message);
    }
  }

  waitForPreparationToCompleteThenDownload(timeElapsedSecs, preparationId, downloadFileAfterSave, delaySecs) {
    try {
      if (timeElapsedSecs > 30 * 60) {
        this.logger.write2log("PAGE: waitForPreparationToCompleteThenDownload.1", "Timeout", "E");
        this.waitForPreparationToCompleteFailed();
        return undefined;
      }

      var promise = new Promise((resolve, reject) => {
        this.http.get("api/gallery/documentpreparestatus/" + preparationId).subscribe({
          next: (data: any) => {
            if (data.done === false) {
              if (delaySecs > 10) delaySecs = 10;

              setTimeout(() => {
                this.waitForPreparationToCompleteThenDownload(timeElapsedSecs + delaySecs, preparationId, downloadFileAfterSave, delaySecs + 3)
              }, delaySecs * 1000);
            } else {
              if (data.error == 'NONE') {
                this.logger.write2log("PAGE: waitForPreparationToCompleteThenDownload", "Got DONE status for document preparation: OK", "P");

                var downloadUrl = downloadFileAfterSave.replace("/documentprepare/", "/document/") + "&downloadprepared=1";
                if (wrapperUseDynamicDNSSupport()) {
                  wrapperSetServerSessionStorageParams();
                  downloadUrl = sessionStorage.getItem('baseUrl') + downloadUrl + "&ssid=" + sessionStorage.getItem('baseServerId') + "&sspid=" + sessionStorage.getItem('baseServerPid');
                }
                this.logger.write2log("savePage", "[" + this.swrp + "][" + this.userId + "] -- Downloading: " + downloadUrl, "P");
                if (this.previewPDFWindow) {
                  this.previewPDFWindow.location = downloadUrl + "&PreviewOnly=true";
                } else {
                  window.location.href = downloadUrl;
                }
                this.gallery.setDocumentChangedSinceLastDownload(false)
                this.hideLoaderWithMessage();

              } else {
                this.logger.write2log("PAGE: waitForPreparationToCompleteThenDownload", "Got DONE status for document preparation: ERROR " + data.error, "P");
                this.waitForPreparationToCompleteFailed();
              }
            }
          },
          error: (err: any) => {
            this.logger.write2log('gallery.waitForPreparationToCompleteThenDownload.ERROR', 'Got response code ' + err.status, 'E');
            this.hideLoaderWithMessage();
          }
        });
      });
      return promise;


    } catch (e) {
      this.logger.logInternalError("PAGE: waitForPreparationToCompleteThenDownload.2", e.message);
      this.waitForPreparationToCompleteFailed();
      return undefined;
    }
  }

  didDocumentChangeSinceLastDownload() {
    return this.gallery.getDocumentChangedSinceLastDownload();
  }

  showUnsavedChangesTooltip() {
    try {
      return this.didDocumentChangeSinceLastDownload() && this.hasElapsedEnoughTimeSinceUnsavedTooltipClosureToShowAgain;
    } catch (e) {
      this.logger.logInternalError("PAGE: showUnsavedChangesTooltip", e.message);
      return false;
    }
  }

  closeUnsavedChangesTooltip() {
    try {
      this.gallery.setUnsavedChangesTooltipClosedTime(new Date());
      this.hasElapsedEnoughTimeSinceUnsavedTooltipClosureToShowAgain = false;
    } catch (e) {
      this.logger.logInternalError("PAGE: closeUnsavedChangesTooltip", e.message);
    }
  }

  startUnsavedChangesTooltipTimer() {
    try {
      this.unsavedChangesTooltipTimer = setTimeout(() => {
        this.updateHasElapsedEnoughTimeSinceUnsavedTooltipClosureToShowAgain();
      }, 1000 * 60);  // Run once per minute
    } catch (e) {
      this.logger.logInternalError("PAGE: startUnsavedChangesTooltipTimer", e.message);
    }
  }

  updateHasElapsedEnoughTimeSinceUnsavedTooltipClosureToShowAgain() {
    var now = new Date();
    this.hasElapsedEnoughTimeSinceUnsavedTooltipClosureToShowAgain = (now.getTime() - this.gallery.getUnsavedChangesTooltipClosedTime().getTime() > 1000 * 60 * 10); // We do not show tooltip for 10 minutes after last time it was closed
  }

  clearUnsavedChangesTooltipTimer() {
    try {
      if (this.unsavedChangesTooltipTimer !== null) {
        //$interval.cancel(this.clearUnsavedChangesTooltipTimer);
        this.unsavedChangesTooltipTimer = null;
      }
    } catch (e) {
      this.logger.logInternalError("PAGE: clearUnsavedChangesTooltipTimer", e.message);
    }
  }

  waitForPreparationToCompleteFailed() {
    try {
      this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorSavingFile'));
      this.hideLoaderWithMessage();
    } catch (e) {
      this.logger.logInternalError("PAGE: waitForPreparationToCompleteFailed", e.message);
    }
  }

  /**
         * Saves the current page and downloads it
         */
  saveAndDownload(fileType: any = undefined, dontStopEditing: any = undefined) {
    try {
      if (fileType === 'swrd') {
        this.user.setDownloadPDFWithOCR(false);
      }
      if (dontStopEditing != true) {
        this.stopEditingCurrentElement();
        setTimeout(() => { this.saveAndDownload(fileType, true) }, 0);
        return;
      }

      if (this.token) {
        // Save in combination with integration with client.
        this.logger.write2log("saveAndDownload", "[" + this.swrp + "][" + this.userId + "] Getting download link...", "P");
        this.apiV1.getDownloadUrl(this.token, fileType).then(
          data => {
            if (data && data['status'] === 0) {
              var downloadUrl = data['url'];
              if (wrapperUseDynamicDNSSupport()) {
                downloadUrl += "&ssid=" + sessionStorage.getItem('baseServerId') + "&sspid=" + sessionStorage.getItem('baseServerPid');
              }
              this.logger.write2log("saveAndDownload", "[" + this.swrp + "][" + this.userId + "] Got download link: " + data['url'], "P");
              console.log("downloadUrl", downloadUrl);
              window.location = downloadUrl;
            } else {
              this.logger.write2log("saveAndDownload", "[" + this.swrp + "][" + this.userId + "] Could not get download link!", "E");
              this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotDownloadFile'));
            }
          }
        )
      } else {
        // Save without integration with client
        this.logger.write2log("saveAndDownload", "[" + this.swrp + "][" + this.userId + "] Saving document for download...", "P");
        var downloadPDFWithOCR = this.user.getDownloadPDFWithOCR();
        if (downloadPDFWithOCR) {
          this.doShowChooseOCRLangDialog();
        } else {
          var getDownloadPNGPage = this.user.getDownloadPNGPage();
          if (getDownloadPNGPage > 0) {
            this.save(true, 'api/gallery/documentprepare/' + encodeURIComponent(this.document) + "." + fileType + "?ReturnPDFWithOCR=0&PageNumber=" + getDownloadPNGPage);
          } else {
            this.save(true, 'api/gallery/documentprepare/' + encodeURIComponent(this.document) + "." + fileType + "?ReturnPDFWithOCR=0");
          }
        }
      }
    } catch (e) {
      this.logger.logInternalError("PAGE: saveAndDownload", e.message);
    }
  }

  startDownloadPDFWithOCR() {

    this.doHideChooseOCRLangDialog();

    var selectedOCRLangs = '';
    for (var i = 0; i < this.OCRLangs.length; i++) {
      if (this.OCRLangs[i].selected) {
        selectedOCRLangs += (selectedOCRLangs === '' ? '' : ' ') + this.OCRLangs[i].code;
      }
    }
    if (selectedOCRLangs === '')
      selectedOCRLangs = 'eng';

    var apiUrl = 'api/gallery/documentprepare/' + encodeURIComponent(this.document) + ".pdf?ReturnPDFWithOCR=1&OCRLangs=" + encodeURIComponent(selectedOCRLangs);
    this.logger.write2log("startDownloadPDFWithOCR", "[" + this.swrp + "][" + this.userId + "] Saving: " + apiUrl, "P");
    this.save(true, apiUrl);
  }

  OCRLangSelectionChanged() {
    try {
      if (!this.OCRLangs || this.OCRLangs.length === 0)
        return;

      var selectedCount = 0;
      var selectedOCRLanguagesList = '';
      this.selectedOCRLanguages = '';

      for (var i = 0; i < this.OCRLangs.length; i++) {
        var lang = this.OCRLangs[i];
        if (lang.selected) {
          selectedCount++;
          this.selectedOCRLanguages += (this.selectedOCRLanguages === '' ? '' : ', ') + lang.name;
          selectedOCRLanguagesList += ';' + lang.code + ';';
        }
      }

      this.noMoreOCRLanguages = (selectedCount >= 4);
      this.showNoOCRLangWarning = (selectedCount === 0);
      this.user.setSelectedOCRLanguages(selectedOCRLanguagesList);

    } catch (e) {
      this.logger.logInternalError("OCRLangSelectionChangedd", e.message);
    }
  }

  /**
         * Checks if user has a subscription and either:
         * 1. downloads the document if user has a subscription, OR:
         * 2. shows download dialog where user can subscribe to a subscription or download document with watermark;
         * 
         * 'previewOnly' = show generated PDF file in new window (for print purposes) instead of downloading it.
         * 'pageNo' = -1 for PDF and SWRD file types, because we download the whole document, > 0 (1-based index) for PNG
         */
  checkSubscriptionAndDownload(fileType: any = undefined, downloadPDFWithOCR: any = undefined, previewOnly: any = undefined, pageNo: any = undefined) {
    // Check filetype
    if (fileType != undefined) {
      this.downloadFileType = fileType;
      this.user.setDownloadFileType(fileType);
    } else {
      fileType = this.user.getDownloadFileType();
      if (fileType == undefined) {
        fileType = 'pdf';
      }
    }

    // Check whether we must perform OCR
    if (downloadPDFWithOCR != undefined) {
      this.downloadPDFWithOCR = downloadPDFWithOCR;
      this.user.setDownloadPDFWithOCR(downloadPDFWithOCR);
    } else {
      downloadPDFWithOCR = this.user.getDownloadPDFWithOCR();
      if (downloadPDFWithOCR == undefined) {
        downloadPDFWithOCR = false;
      }
    }

    // Check whether we only need to preview PDF for print.
    if (previewOnly != undefined) {
      this.previewOnly = previewOnly;
      this.user.setPreviewPDFOnly(previewOnly);
    } else {
      previewOnly = this.user.getPreviewPDFOnly();
      if (previewOnly == undefined) {
        previewOnly = false;
      }
    }

    // Check which page do we need to download.
    if (pageNo != undefined) {
      pageNo = pageNo;
      this.user.setDownloadPNGPage(pageNo);
    } else {
      pageNo = this.user.getDownloadPNGPage();
      if (pageNo == undefined) {
        pageNo = 1;
      }
    }

    // Start download/preview
    var upgradeReason = (downloadPDFWithOCR ? this.UPGRADE_DOWNLOAD_SEARCHABLE_PDF : this.UPGRADE_DOWNLOAD_PDF);
    if (this.userId) {
      if (previewOnly) {
        this.previewPDFWindow = window.open(document.location.href.split('#')[0] + "#!/print/preview", "_blank");
      } else {
        this.previewPDFWindow = null;
      }
      this.user.hasSubscription(!downloadPDFWithOCR, downloadPDFWithOCR).then(
        data => {
          if (data['status'] == 1) {
            this.saveAndDownload(fileType);
          } else {
            this.closePreviewWindow();
            this.doShowUpgradeOptions(upgradeReason);
          }
        }
      );
    } else {
      this.saveAndDoShowSubscriptionDialog(-1, '', upgradeReason);
    }
  }

  closePreviewWindow() {
    try {
      if (this.previewPDFWindow) {
        this.previewPDFWindow.close();
      }
    } catch (e) {
      this.logger.logInternalError('closePreviewWindow', e.message);
    }
  }

  checkSubscriptionAndStartPurchaseOfSubscriptionOrDownload(fileType) {
    var upgradeReason = (this.downloadPDFWithOCR ? this.UPGRADE_DOWNLOAD_SEARCHABLE_PDF : this.UPGRADE_DOWNLOAD_PDF);
    if (this.userId) {
      this.user.hasSubscription(!this.downloadPDFWithOCR, this.downloadPDFWithOCR).then(
        data => {
          if (data['status'] == 1) {
            this.saveAndDownload(fileType);
          } else {
            this.storeid = data['id'];
            this.storehash = data['hash'];
            this.saveAndDoShowUpgradeOptions(upgradeReason);
          }
        }
      );
    } else {
      this.saveAndDoShowSubscriptionDialog(-1, '', upgradeReason);
    }
  }

  saveAndDoShowSubscriptionDialog(id: any = undefined, hash: any = undefined, upgradeReason: any = undefined, dontStopEditing: any = undefined) {
    try {
      if (this.pageModified) {
        if (dontStopEditing != true) {
          this.stopEditingCurrentElement();
          setTimeout (() => { this.saveAndDoShowSubscriptionDialog(id, hash, upgradeReason, true) }, 0);
          return;
        }

        this.save(true).then (() => {
          this.doShowSubscriptionDialog(id, hash, upgradeReason);
        });
      } else {
        this.doShowSubscriptionDialog(id, hash, upgradeReason);
      }
    } catch (e) {
      this.logger.logInternalError('saveAndDoShowSubscriptionDialog', e.message);
    }
  }

  doShowSubscriptionDialog(id, hash, upgradeReason) {
    this.storeid = id;
    this.storehash = hash;
    this.storereason = upgradeReason;
    this.showSubscriptionDialog = true;
  }

  doHideSubscriptionDialog() {
    this.showSubscriptionDialog = false;
  }

  doShowChooseOCRLangDialog() {
    try {

      this.showChooseOCRLang = true;

      if (this.OCRLangs === null || this.OCRLangs === undefined || this.OCRLangs.length === 0) {

        this.showChooseOCRLangProgress = true;

        this.apiV1.getOCRLangs(wrapperGetSiteLanguage()).then(
          data => {
            try {

              var selectedLangs = this.user.getSelectedOCRLanguages();
              if (selectedLangs === null || selectedLangs === '') {
                selectedLangs = ';eng;';
              }

              if (data && data['status'] === 0) {
                this.OCRLangs = data['languages'];
                if (this.OCRLangs) {
                  for (var i = this.OCRLangs.length - 1; i >= 0; i--) {
                    if (selectedLangs.indexOf(';' + this.OCRLangs[i].code + ';') >= 0) {
                      this.OCRLangs[i].selected = true;
                    }
                    if (this.OCRLangs[i].name + '' === '') {
                      this.OCRLangs.splice(i, 1);
                    }
                  }
                }
                this.OCRLangSelectionChanged();
              } else {
                this.doHideChooseOCRLangDialog();
              }

              this.moveSelectedOCRLanguagesToStart();
              this.showChooseOCRLangProgress = false;

            } catch (e) {
              this.logger.logInternalError("doShowChooseOCRLangDialog.data", e.message);
            }
          }
        );

      } else {
        this.moveSelectedOCRLanguagesToStart();
      }

    } catch (e) {
      this.logger.logInternalError("doShowChooseOCRLangDialog.data", e.message);
    }
  }

  moveSelectedOCRLanguagesToStart() {
    try {
      if (this.OCRLangs == null || this.OCRLangs == undefined || this.OCRLangs.length == 0)
        return;

      var movedLangsCount = 0;

      for (var i = this.OCRLangs.length - 1; i >= movedLangsCount; i--) {
        var lang = this.OCRLangs[i];
        if (lang.selected) {
          this.OCRLangs.splice(i, 1);
          this.OCRLangs.unshift(lang);
          movedLangsCount++;
          i++;
        }
      }

    } catch (e) {
      this.logger.logInternalError("moveSelectedOCRLanguagesToStart", e.message);
    }
  }


  doHideChooseOCRLangDialog() {
    this.showChooseOCRLang = false;
  }

  saveAndDownloadAndCloseDownloadDialog(fileType, downloadPDFWithOCR) {
    if (downloadPDFWithOCR != undefined) {
      this.downloadPDFWithOCR = downloadPDFWithOCR;
      this.user.setDownloadPDFWithOCR(downloadPDFWithOCR);
    }
    this.saveAndDownload(fileType);
    this.doHideSubscriptionDialog();
  }

  /**
         * Saves the current page and redirects the user to the client application.
         */
  saveAndContinue(dontStopEditing) {

    if (dontStopEditing != true) {
      this.stopEditingCurrentElement();
      setTimeout (() => { this.saveAndContinue(true) }, 0);
      return;
    }

    if (this.token === undefined) {
      this.dialogs.openMessageDialog(this.translateService.instant('Error'), 'No API token!');
      return;
    }

    this.showLoaderWithMessage(this.translateService.instant('SavingFile'));

    // Save the document
    if (this.pageModified) {

      this.save().then(
        data => {

          if (data === undefined || data['status'] !== 0) {
            this.hideLoaderWithMessage();
            this.logger.write2log('saveAndContinue', 'Error while saving', 'E');
            this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorSavingFile'));
            return;
          }

          this.showLoaderWithMessage(this.translateService.instant('ExportingFile'));

          this.apiV1.prepareForClient(this.document, this.token, true).then(

            data => {
              if (data !== undefined && data['status'] === 0) {
                window.location = data['redirectUrl'];
              } else {
                this.hideLoaderWithMessage();
                this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorExportingFile'));
                return;
              }
            }

          );

        }
      );

    } else {

      this.showLoaderWithMessage(this.translateService.instant('ExportingFile'));

      this.apiV1.prepareForClient(this.document, this.token, false).then(

        data => {
          if (data !== undefined && data['status'] === 0) {
            window.location = data['redirectUrl'];
          } else {
            this.hideLoaderWithMessage();
            this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorExportingFile'));
            return;
          }
        });
    }
  }

  /**
         * Redirects the user to the client application without saving the page. The client
         * application is notified that the user has canceled the editing.
         */
  cancelAndContinue() {

    this.showLoaderWithMessage(this.translateService.instant('Redirecting'));

    this.apiV1.prepareForClient(this.document, this.token).then(
      data => {
        if (data !== undefined && data['status'] === 0) {
          var url = data['redirectUrl'];
          url += "&cancel=yes"
          window.location = url;
        } else {
          this.hideLoaderWithMessage();
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotRedirectToClient'));
          return;
        }
      }
    );

  }

  back() {
    var path = "/gallery/" + encodeURIComponent(this.document);
    if (this.token) {
      //$location.path(path).search(this.searchParam);
      this.router.navigate([path],  this.searchParam);
    }
    else  {
      //$location.path(path);
      this.router.navigate([path], {});
    }
  }

  loadPage() {

    this.showLoaderFunction();
    this.pageIsLoaded = false;
    this.loaderMessage = this.translateService.instant('OpeningPage');

    return this.gallery.getPage(this.document, this.swrp, this.token)
      .then(async data => {

        this.showLoader = false;
        this.hideLoaderWithDelay();

        if (data === undefined || data['status'] !== 0) {
          await this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorLoadingFile')/*, () { back(); }*/);
          this.router.navigate(["/gallery/"]);
          return;
        }

        // Will scale the page after load
        this.pageScaled = false;

        this.page = data['page'];
        this.page.texts = [];
        this.page.imageSignatures = [];
        this.page.markers = [];
        this.page.filters = [];
        this.userId = data['userId'];

        this.cropAllowed = true;

        for (var i = 0; i < this.page.elements.length; i++) {
          var el = this.page.elements[i];

          el.selected = false;

          if (el.elementIdentificator === 0) {
            // Background image
            this.page.background = el;
          }
          else if (el.elementIdentificator === 5) {
            this.page.thumbnail = el;
          }
          else if (el.elementIdentificator === 1) {
            // Text elements
            el.font = "" + el.font; // change font identifier to string
            this.page.texts.push(el);
            this.cropAllowed = false;
          }
          else if (el.elementIdentificator === 8) {
            this.page.imageSignatures.push(el);
            this.cropAllowed = false;
          }
          else if (el.elementIdentificator === 3 || el.elementIdentificator === 4 || el.elementIdentificator === 7) {
            this.page.markers.push(el);
            this.cropAllowed = false;
          }
          else if (el.elementIdentificator === 9 || el.elementIdentificator === 10 || el.elementIdentificator === 11 || el.elementIdentificator === 12 || el.elementIdentificator === 13) {
            this.page.filters.push(el);
            this.cropAllowed = false;
          }

          this.hideLoaderWithMessage();

          this.pageModified = false;
          this.backgroundWasModified = false;
          this.documentModified = data['documentModified'];
          this.pageIsLoaded = true;
        }

      });
  }

  loadPageMoves(jumpToPageNo: any = undefined) {
    this.gallery.getPageMoves(this.document, this.swrp, jumpToPageNo).then(
      data => {
        if (data === undefined) return;
        if (jumpToPageNo && !this.clientMode) {
          // Jump to page
          this.openPage(data['requestedPage']);
        } else {
          // Save returned data
          this.nextPage = data['nextPage'];
          this.prevPage = data['previousPage'];
          this.pageCount = data['totalPagesCount'];
          this.currentPageNo = (data['currentPage'] + 1);
          if (this.prevPage) {
            this.prevPageUrl = "#!/gallery/" + encodeURIComponent(this.document) + "/" + encodeURIComponent(this.prevPage);
            if (this.token) this.prevPageUrl += "?token=" + this.token;
          }
          this.currentPage = data['currentPage'];
        }
      }
    );
  }

  deletePage() {
    if (!this.nextPage && !this.prevPage)
      return;

    this.gallery.deletePage(this.document, this.swrp, this.currentPageNo.toString()).then(
      data => {
        if (data !== undefined && data['status'] === 0) {
          this.pageModified = false;
          this.gallery.setDocumentChangedSinceLastDownload(true);
          if (this.nextPage)
            this.gotoNextPage(true);
          else
            this.gotoNextPage(false);
        }
      });

  }
  markPageAsDirty() {
    try {
      this.pageModified = true;
      this.gallery.setDocumentChangedSinceLastDownload(true);
    } catch (e) {
      this.logger.logInternalError("PAGE: markPageAsDirty", e.message);
    }
  }

  askDeletePage() {
    this.dialogs.openDeleteDialog(this.translateService.instant('ThisPage'), null, id => {
      this.deletePage();
    });
  }

  insertPage() {
    var uploadTag = document.getElementById("fileInput");
    if (uploadTag) uploadTag.click();
  }

  uploadFileFromFileInput(event: any) {
    const file = event.target.files[0];
    this.upload(file);
  }

  upload(paramF: any = undefined) {
    if (this.clientMode)
      return;

    var f = document.getElementById("fileInput") as HTMLInputElement;

    var file;
    if (paramF)
      file = paramF;
    else
      file = f.files[0];
    var fileName = file.name;
    var fileType = "";

    if (file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf")) {
      fileType = "pdf";
    } else if (file.type === "application/msword" || file.name.toLowerCase().endsWith(".doc")) {
      fileType = "doc";
    } else if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || file.name.toLowerCase().endsWith(".docx")) {
      fileType = "docx"
    } else if (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.name.toLowerCase().endsWith(".xlsx")) {
      fileType = "xlsx"
    } else if (file.type === "application/vnd.ms-excel" || file.name.toLowerCase().endsWith(".xls")) {
      fileType = "xls";
    } else if (file.type === "application/vnd.ms-powerpoint" || file.name.toLowerCase().endsWith(".ppt")) {
      fileType = "ppt";
    } else if (file.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation" || file.name.toLowerCase().endsWith(".pptx")) {
      fileType = "pptx";
    } else if (file.type === "image/jpeg" || file.name.toLowerCase().endsWith(".jpg") || file.name.toLowerCase().endsWith(".jpeg")) {
      fileType = "jpg";
    } else if (file.type === "image/gif" || file.name.toLowerCase().endsWith(".gif")) {
      fileType = "gif";
    } else if (file.type === "image/png" || file.name.toLowerCase().endsWith(".png")) {
      fileType = "png";
    } else if (file.type === "image/bmp" || file.name.toLowerCase().endsWith(".bmp")) {
      fileType = "bmp";
    } else if (file.type === "application/vnd.oasis.opendocument.text" || file.type === "application/odt" || file.name.toLowerCase().endsWith(".odt")) {
      fileType = "odt";
    } else if (file.type === "application/vnd.oasis.opendocument.spreadsheet" || file.type === "application/ods" || file.name.toLowerCase().endsWith(".ods")) {
      fileType = "ods";
    } else if (file.type === "application/vnd.oasis.opendocument.presentation" || file.type === "application/odp" || file.name.toLowerCase().endsWith(".odp")) {
      fileType = "odp";
    } else if (file.name.toLowerCase().endsWith(".hwp") || file.type === "application/hwp") {
      fileType = "hwp";
    } else if (file.name.toLowerCase().endsWith(".swrd") || file.type === "application/swrd") {
      fileType = "swrd";
    } else if (file.name.toLowerCase().endsWith(".pages") || file.type === "application/x-iwork-pages-sffpages") {
      fileType = "pages";
    } else if (file.name.toLowerCase().endsWith(".key") || file.type === "application/x-iwork-keynote-sffkey") {
      fileType = "key";
    } else if (file.name.toLowerCase().endsWith(".numbers") || file.type === "application/x-iwork-numbers-sffnumbers") {
      fileType = "numbers";
    } else if (file.name.toLowerCase().endsWith(".tif") || file.type === "image/tif" || file.type === "image/x-tif" || file.type === "application/tif" || file.type === "application/x-tif") {
      fileType = "tif";
    } else if (file.name.toLowerCase().endsWith(".tiff") || file.type === "image/tiff" || file.type === "image/x-tiff" || file.type === "application/tiff" || file.type === "application/x-tiff") {
      fileType = "tiff";
    } else if (file.name.toLowerCase().endsWith(".vsdx") || file.type === "application/vsdx") {
      fileType = "vsdx";
    } else if (file.name.toLowerCase().endsWith(".vsd") || file.type === "application/vsd" || file.type === "application/vnd.visio") {
      fileType = "vsd";
    } else if (file.name.toLowerCase().endsWith(".vdx") || file.type === "application/vdx") {
      fileType = "vdx";
    } else if (file.name.toLowerCase().endsWith(".heic") || file.type === "image/heic" || file.type === "image/heif") {
      fileType = "heic";
    } else {
      try {
        var fileParts = fileName.split(".");
        var fileExt = fileParts[fileParts.length - 1];
        if (fileExt.toLowerCase() === "swrd") {
          fileType = "swrd";
        }
      } catch (e) {
        // Ignore this error?
      }
    }


    if (fileType === "") {
      this.dialogs.openMessageDialog(this.translateService.instant('SelectDocument'), this.translateService.instant('UnsupportedFileFormat'));
      this.resetFileInput();
      return;
    }

    var data = new FormData();
    data.append('file', file);

    this.showLoaderWithMessage(this.translateService.instant('Inserting'));

    this.gallery.upload(data, fileName, fileType, (this.currentPageNo - 1)).then(
      data => {
        if (data !== undefined && data['status'] === 0) {
          var pages = data['pages'];
          if (pages && pages.length > 0) {
            this.openPage(pages[0]);
          }
          else {
            this.logger.write2log("PAGE UPLOAD", "Number of new pages == 0", "W");
            this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotOpenFile'));
          }
        } else {
          this.hideLoader();
          this.logger.write2log("PAGE UPLOAD", "Failed to open document", "W");
          this.resetFileInput();
          switch (data['status']) {
            case -2:
              this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotOpenFileTooBig'));
              break;
            default:
              this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotOpenFile'));
              break;
          }
        }
      }
    );
  }

  resetFileInput() {
    var form = document.getElementById("fileInputForm") as HTMLFormElement;
    if (form) form.reset();
  }

  gotoNextPage(nxt) {
    var nextPage = nxt ? this.nextPage : this.prevPage;
    this.openPage(nextPage);
  }

  openPage(nextPage: any = undefined, dontStopEditing: any = undefined) {
    if (dontStopEditing != true) {
      this.stopEditingCurrentElement();
      setTimeout(() => { this.openPage(nextPage, true) }, 0);
      return;
    }

    if (this.pageModified) {
      this.save().then(
        data => {
          if (data !== undefined && data['status'] === 0) {
            if (nextPage) {
              var nextUrl = "/gallery/" + encodeURIComponent(this.document) + "/" + encodeURIComponent(nextPage);
              this.dialogs.dismissAllDialogs();
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigateByUrl(nextUrl);
              });
            }
          } else {
            this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorSavingFile'));
          }
        }
      );
    } else {
      if (nextPage) {
        var nextUrl = "/gallery/" + encodeURIComponent(this.document) + "/" + encodeURIComponent(nextPage);
        this.dialogs.dismissAllDialogs();
        //$location.path(nextUrl);
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigateByUrl(nextUrl);
        });
        //this.router.navigate([nextUrl], { skipLocationChange: true });
      }
    }
  }

  // Toggle window where we ask user to which page to jump to
  togglePageSelector() {
    this.showPageSelector = !this.showPageSelector;
    if (this.showPageSelector) {
      this.jumpToPage = (this.clientMode ? this.clientCurrentPage : this.currentPageNo);
      setTimeout(() => {
        var e = document.getElementById('pageSelectorInput') as HTMLInputElement;
        if (e) {
          e.focus();
          e.select();
        }
      }, 1);
    }
  }

  // Close window where we ask user to which page to jump to
  closePageSelector() {
    this.showPageSelector = false;
  }

  // Handle 'Enter' and 'Escape' key press on page selector
  handleKeyPressOnPageSelector(keyCode) {
    if (keyCode === 13) {
      this.closePageSelector();
      this.goToPage(this.jumpToPage);
    } else if (keyCode === 27) {
      this.closePageSelector();
    }
  }

  // Jump to page
  goToPage(pageNo) {

    if (!pageNo)
      return;

    var pageCount = (this.clientMode ? parseInt(this.clientPageCount) : this.pageCount);
    var currentPage = (this.clientMode ? parseInt(this.clientCurrentPage) : parseInt(this.currentPageNo));

    if (pageNo === currentPage) {
      this.closePageSelector();
      return;
    }

    if (pageNo < 1)
      pageNo = 1;
    if (pageNo > pageCount)
      pageNo = pageCount;

    if (this.clientMode) {
      this.clientOpenPage(pageNo);
    } else {
      this.loadPageMoves(pageNo);
    }

  }

  clientGoPrevPage() {
    var currentPage = parseInt(this.clientCurrentPage);
    this.clientOpenPage(currentPage - 1);
  }

  clientGoNextPage() {
    var currentPage = parseInt(this.clientCurrentPage);
    this.clientOpenPage(currentPage + 1)
  }

  savePageToClient() {
    return this.save().then(

      data => {

        if (data === undefined || data['status'] !== 0) {
          this.showLoader = false;
          this.hideLoaderWithDelay();
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorSavingFile'));
          return false;
        }

        this.message = this.translateService.instant('ExportingFile');

        return true;

      }).then(

        ok => {

          if (!ok) return false;

          // 2. Export for client
          return this.apiV1.prepareForClient(this.document, this.token).then(
            data => {
              if (data === undefined || data['status'] !== 0) {
                this.showLoader = false;
                this.hideLoaderWithDelay();
                this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorExportFile'));
                return false;
              }
              this.showLoaderWithMessage(this.translateService.instant('ReplacingFile'));
              return true;
            }
          );
        }
      );
  }

  // We want to edit the next page from the client:
  // 0. Complete active editing
  // 1. Save the page
  // 2. Export for the client
  // 3. Request the new page from the client
  // 4. Update the page using the edit route
  // If the page has not been changed, only step 3. and 4.
  //
  // pageNo starts with 1 (1,2,3,4,5,...)
  clientOpenPage(pageNo: any = undefined, dontStopEditing: any = undefined) {

    // 0. Complete active editing
    if (dontStopEditing != true) {
      this.stopEditingCurrentElement();
      setTimeout(() => { this.clientOpenPage(pageNo, true) }, 0);
      return undefined;
    }

    // 1. Save the page
    console.debug('Going to page ' + pageNo);
    this.showLoaderFunction();
    if (this.pageModified) {
      this.savePageToClient().then(
        ok => {
          if (!ok) return undefined;
          return this.requestReplacePage(pageNo, true);
        }
      );
    } else {
      return this.requestReplacePage(pageNo, false)
    }

    return undefined;
  }

  requestReplacePage(nextPage: any = undefined, pageModified: any = undefined) {

    return this.apiV1.requestReplacePage(nextPage, this.token, pageModified, this.clientPageCount).then(
      data => {
        if (data !== undefined && data['status'] == 0) {

          var path = "/edit/" + data['clientId'] + "/" + this.token;
          this.dialogs.dismissAllDialogs();
          //$location.path(path).search('page', nextPage);
          this.router.navigate([path], { queryParams: { grayscale: true, page: nextPage, pagecount: this.clientPageCount } });
        } else {
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorReplacingFile'));
        }
      }
    );

  }

  // =================
  // Edge detection and image filters
  // =================

  cancelCrop() {
    this.cropActive = false;
    this.cropStyle = { display: "none" };
    this.page.imageSignatures = this.undo['imageSignaturesg'];
    this.page.markers = this.undo['markers'];
    this.page.texts = this.undo['texts'];
  }

  /**
   * Check if the crop points make sense!
   * @param {any} points
   */
  checkPoints(points) {

    // Check for all zeros!
    if (points.x1 === 0 &&
      points.x2 === 0 &&
      points.x3 === 0 &&
      points.x4 === 0) return false;


    return true;

  }

  /**
   * Returns true/false indicating whether document contains any elements.
   */
  hasDocumentAnyElements() {
    if (this.page.imageSignatures && this.page.imageSignatures.length > 0)
      return true;
    if (this.page.markers && this.page.markers.length > 0)
      return true;
    if (this.page.texts && this.page.texts.length > 0)
      return true;

    return false;
  }

  /**
         * Deletes all elements from the page.
         */
  deleteAllElements(saveForUndo) {
    if (saveForUndo) {
      this.undo['imageSignatures'] = this.page.imageSignatures;
      this.undo['markers'] = this.page.markers;
      this.undo['texts'] = this.page.texts;
    }
    this.page.imageSignatures = [];
    this.page.markers = [];
    this.page.texts = [];
  }

  /**
   * Edge-detection and image crop functions.
   */
  cropBackground() {

    if (!this.cropActive) {

      // Delete all elements from the page
      this.deleteAllElements(true);

      // Perform crop
      var image = this.page.background.image;
      this.showLoaderWithMessage(this.translateService.instant('DetectingEdges'));

      this.gallery.edgeDetection(this.page.background.image, this.document, this.swrp).then(
        data => {
          this.hideLoaderWithMessage();
          if (data !== undefined && data['status'] === 0 && this.checkPoints(data['points'])) {
            var bg = document.getElementById('background');
            this.cropPoints = data['points'];
            this.currentCropPoints = [this.cropPoints['x1'], this.cropPoints['y1'], this.cropPoints['x2'], this.cropPoints['y2'], this.cropPoints['x3'], this.cropPoints['y3'], this.cropPoints['x4'], this.cropPoints['y4']];
            this.cropStyle = {
              display: 'inline',
              width: bg['width'],
              height: bg['height']
            };
            this.cropActive = true;
          } else {
            var bg = document.getElementById("background");
            this.cropPoints = {
              x1: 20, y1: 20,
              x2: bg['width'] - 20, y2: 20,
              x3: bg['width'] - 20, y3: bg['height'] - 20,
              x4: 20, y4: bg['height'] - 20
            };
            this.currentCropPoints = [this.cropPoints['x1'], this.cropPoints['y1'], this.cropPoints['x2'], this.cropPoints['y2'], this.cropPoints['x3'], this.cropPoints['y3'], this.cropPoints['x4'], this.cropPoints['y4']];
            this.cropStyle = {
              display: 'inline',
              width: bg['width'],
              height: bg['height']
            };
            this.cropActive = true;
          }
        }
      );

    } else {

      // OPT: showLoaderWithMessage(translations['CropImage']);
      this.cropActive = false;
      this.cropStyle = {
        display: 'none'
      };

      var x1 = this.currentCropPoints[0];
      var y1 = this.currentCropPoints[1];
      var x2 = this.currentCropPoints[2];
      var y2 = this.currentCropPoints[3];
      var x3 = this.currentCropPoints[4];
      var y3 = this.currentCropPoints[5];
      var x4 = this.currentCropPoints[6];
      var y4 = this.currentCropPoints[7];

      var cropArea = Math.abs((x1 * y2 - x2 * y1) + (x2 * y3 - x3 * y2) + (x3 * y4 - x4 * y3) + (x4 * y1 - x1 * y4)) / 2;
      var bg = $("#background");
      var imageArea = bg.height() * bg.width();
      var ratio = cropArea / imageArea;

      if (ratio < 0.1) {
        this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('PleaseSelectBiggerRectangle'));
        // OPT: hideLoaderWithMessage();
        return;
      }

      // OPT:
      this.applyImageFilter('crop');
    }
  }

  /**
         * Rotates page 90 degrees clockwise. 
         */
  rotate() {
    this.applyImageFilter('rcw');
  }

  /**
   * Applies image filter to background.
   *
   * @param {any} filter can be 'original', 'normalize', 'grayscale', or 'rcw'.
   */
  applyImageFilter(filter) {

    if ((this.originalBackground === undefined) ||
      (this.undoAction != filter && (filter == 'grayscale' || filter == 'normalize' || filter == 'crop' || filter == 'rcw'))) {
      this.originalBackground = this.page.background.image;
      if (filter == 'crop' || filter == 'rcw')
        this.deleteAllElements(true);
    }

    if (filter === "original" && this.originalBackground !== undefined) {
      this.pageScaled = false; // scale the image after load
      this.page.background.image = this.originalBackground;
      this.originalBackground = undefined;
      if (this.undoAction == this.UNDO_ACTION_CROP || this.undoAction == this.UNDO_ACTION_RCW) {
        this.page.imageSignatures = this.undo['imageSignatures'];
        this.page.markers = this.undo['markers'];
        this.page.texts = this.undo['texts'];
      }
      this.undoAction = this.UNDO_ACTION_NONE;
      return;
    }

    if (filter == 'crop')
      this.showLoaderWithMessage(this.translateService.instant('CropImage'));
    else if (filter == 'rcw')
      this.showLoaderWithMessage(this.translateService.instant('Rotating'));
    else
      this.showLoaderWithMessage(this.translateService.instant('ApplyingImageFilter'));

    var colorParts = [255, 255, 255, 1];
    if (this.normalizeColor !== undefined) {
      try {
        var rgba = this.normalizeColor.substring(5, this.normalizeColor.length - 1).split(",");
        colorParts[0] = parseInt(rgba[0]);
        colorParts[1] = parseInt(rgba[1]);
        colorParts[2] = parseInt(rgba[2]);
        colorParts[3] = (100 * parseFloat(rgba[3]))/*.toFixed()*/;
      } catch (e) {
        this.logger.logInternalError("applyImageFilter", e.message);
      }
    }

    this.gallery.applyImageFilter(this.page.background.image, this.document, this.swrp, filter, this.currentCropPoints, colorParts).then(
      data => {
        this.hideLoaderWithMessage();
        if (data !== undefined && data['status'] === 0) {
          this.page.background.image = data['image'];
          if (filter == 'crop' || filter == 'rcw') this.pageScaled = false;
          this.pageModified = true;
          this.markPageAsDirty();
          this.backgroundWasModified = true;
          this.undoAction = filter;
        } else {
          if (filter == 'crop')
            this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorCropImage'));
          else if (filter == 'rcw')
            this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorRotate'));
          else
            this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorApplyingImageFilter'));
        }
      }
    );
  }

  updateCropPoints(points) {
    this.currentCropPoints = [points.points.x1, points.points.y1, points.points.x2, points.points.y2, points.points.x3, points.points.y3, points.points.x4, points.points.y4];
  }

  cancelCropPoints() {

    this.initMouseMoveHandler(true);

  }

  // =======
  // SELECTING ELEMENTS
  // =======

  selectPmk(id) {

    try {
      this.deselect();
      this.stopEditingCurrentElement();

      this.selectedId = id;
      this.updateElementMoverPosition(id);

      var identifier = id.split("_");

      this.selectedMarker = this.page.markers[parseInt(identifier[1])];
      this.selectedMarker.selected = true;
      this.selectedObj = this.selectedMarker;
      this.selectedMarkerInkSize = this.selectedMarker.inkSize;

    } catch (e) {
      this.logger.logInternalError("PAGE: select PMK", e.message);
    }
  }

  selectText(id) {
    try {
      var prevId = this.selectedId;
      if (prevId !== '') this.deselect();
      if (this.mode != this.MODE_INSERTING_TEXT)
        this.stopEditingCurrentElement();

      this.selectedId = id;
      this.updateElementMoverPosition(id);

      var identifier = id.split("_");

      this.selectedText = this.page.texts[parseInt(identifier[1])];
      this.selectedText.selected = true;
      this.selectedObj = this.selectedText;
      this.inputHasFocus = true;

     if ((!prevId || prevId != id) && document.getElementById(id))
        this.setEndOfContenteditable(document.getElementById(id).children[0]);

    } catch (e) {
      this.logger.logInternalError("PAGE: select TEXT", e.message);
    }
  }

  selectImgSignature(id) {
    try {
      var prevId = this.selectedId;
      if (prevId !== '') this.deselect();   
      this.stopEditingCurrentElement();

      this.selectedId = id;
      this.updateElementMoverPosition(id);

      var identifier = id.split("_");

      this.selectedImgSignature = this.page.imageSignatures[parseInt(identifier[1])];
      this.selectedImgSignature.selected = true;
      this.selectedObj = this.selectedImgSignature;
    } catch (e) {
      this.logger.logInternalError("PAGE: select SIG", e.message);
    }
  }

  deselect(ev: any = undefined) {
    this.selectedId = "";
    this.selectedObj = null;
    this.inputHasFocus = false;
    if (ev !== undefined) this.deselectAllTexts();

    if (this.selectedMarker !== undefined) this.selectedMarker.selected = false;
    if (this.selectedText !== undefined) this.selectedText.selected = false;
    if (this.selectedImgSignature !== undefined) this.selectedImgSignature.selected = false;

    this.selectedText = undefined;
    this.selectedMarker = undefined;
    this.selectedImgSignature = undefined;

    this.handlePageClick(undefined);
  }

  pageModifiedReset(value: boolean) {
    this.pageModifiedElement = false;
    this.cdref.detectChanges();
  }

  setEndOfContenteditable(contentEditableElement) {
    try {

      var range, selection;
      if (document.createRange)   //Firefox, Chrome, Opera, Safari, IE 9+
      {
        range = document.createRange();                     // Create a range (a range is a like the selection but invisible)
        range.selectNodeContents(contentEditableElement);   // Select the entire contents of the element with the range
        range.collapse(false);                              // Collapse the range to the end point. false means collapse to end rather than the start
        selection = window.getSelection();                  // Get the selection object (allows you to change selection)
        selection.removeAllRanges();                        // Remove any selections already made
        selection.addRange(range);                          // Make the range you have just created the visible selection
      }
      else if (document['selection'])    //IE 8 and lower
      {
        range = document.body['createTextRange'];            // Create a range (a range is a like the selection but invisible)
        range.moveToElementText(contentEditableElement);    // Select the entire contents of the element with the range
        range.collapse(false);                              // Collapse the range to the end point. false means collapse to end rather than the start
        range.select();                                     // Select the range (make it the visible selection
      }

    } catch (e) {
      this.logger.logInternalError("PAGE: setEndOfContenteditable", e.message);
    }
  }

  stopEditingCurrentElement() {
    this.applyCanvas();
    this.openEraser(false);
    this.cancelSelectPoint();
    this.mode = this.MODE_IDLE;
  }

  stopEditingAndExecFilter(filterFunction) {
    this.stopEditingCurrentElement();
    if (this.page.filters === undefined) {
      this.page.filters = []
    }
    setTimeout (() => {
      if (filterFunction == 'grayscale'){
        this.page.filters.push({
          __type: "SwrdConverterLib.TWF.TwfGrayscale, SwrdConverterLib.Core",
          elementIdentificator: 9,
        });
        this.applyImageFilter('grayscale');
      }
      else if (filterFunction == 'normalize'){
        this.page.filters.push({
          __type: "SwrdConverterLib.TWF.TwfNormalize, SwrdConverterLib.Core",
          elementIdentificator: 10,
        });
        this.applyImageFilter('normalize');
      }
      else if (filterFunction == 'crop'){
        this.page.filters.push({
          __type: "SwrdConverterLib.TWF.TwfCrop, SwrdConverterLib.Core",
          elementIdentificator: 11,
        });
        this.cropBackground();
      }
      else if (filterFunction == 'rotate'){
        this.page.filters.push({
          __type: "SwrdConverterLib.TWF.TwfRotate, SwrdConverterLib.Core",
          elementIdentificator: 13,
        });
        this.rotate();
      }
    }, 0);
  }

  // ======
  // HANDLING TEXT ELEMENTS
  // ======

  textDelete() {

    try {
      this.undoAction = this.UNDO_ACTION_NONE;
      if (this.selectedId === undefined) return;
      var identifier = this.selectedId.split("_");
      if (identifier[0] !== "txt") return;

      var pos = parseInt(identifier[1]);

      this.page.texts[pos].deleted = true;
      this.page.texts.splice(pos, 1);

      this.markPageAsDirty();
      this.pageModified = true;
      this.pageModifiedElement = true;

      this.page.texts = this.page.texts.filter(te => { return te.text !== '' || te.selected === true });

      this.deselect();
    } catch (e) {
      this.logger.logInternalError("PAGE: delete TEXT", e.message);
    }

  }

  textNew(posX: any = undefined, posY: any = undefined, useLastFontSize: any = undefined, shiftToVerticalCenterOfPosY: any = undefined) {

    this.undoAction = this.UNDO_ACTION_NONE;
    var fontSize = (useLastFontSize && this.lastFontSize ? this.lastFontSize : this.getNewFontSize());
    var letterSpacing = (useLastFontSize && this.lastLetterSpacing ? this.lastLetterSpacing : 0);

    if (shiftToVerticalCenterOfPosY) {
      posY -= Math.floor(fontSize / 2);
    }

    if (posY + (fontSize * 1.3) > this.pageSize.height) {
      posY = Math.floor(this.pageSize.height - (fontSize * 1.3));
    }

    if (posY < 0) {
      posY = 0;
    }

    var newText = {
      __type: "SwrdConverterLib.TWF.TwfTextLine, SwrdConverterLib.Core",
      bold: this.lastFontStyle.bold,
      italic: this.lastFontStyle.italic,
      font: this.lastFontName,
      color: this.lastFontColor | 0,
      elementIdentificator: 1,
      selected: true,
      size: fontSize,
      letterSpacing: letterSpacing,
      x: posX,
      y: posY,
      text: ""
    }
    this.page.texts.push(newText);
    var id = "txt_" + (this.page.texts.length - 1);

    this.selectText(id);

    this.cropAllowed = false;
    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
    this.lastFontSize = fontSize;
    this.lastLetterSpacing = letterSpacing;

    setTimeout(() => {
      try {
        document.getElementById(id).getElementsByTagName("input")[0].focus();
      } catch (e) {
        this.logger.logInternalError("PAGE: new text activation", e.message);
      }
    }, 30, false);

    return newText;
  }

  getNewFontSize() {

    // Normal A4 page can contain up to 55 lines
    // Let's return a font size that can be put in 55 lines.

    // Are we showing portrait document?
    var bg = document.getElementById("background");
    var portrait = (bg['height'] > bg['width']);

    // Get height of the document (or width in landscape mode)
    var side = (portrait ? bg['height'] : bg['width']);

    // Get font size
    var fontSize = Math.floor(side / 55);

    // Do not allow sizes smaller than 20.
    fontSize = Math.max(20, fontSize);

    // Return size
    return fontSize;

  }

  onSelectedTextChanged() {
    // If user changed the text, then we must clear the undo action.
    // Every user's action should remove the undo option.
    this.undoAction = this.UNDO_ACTION_NONE;
  }

  /**
         * We have an enter keypress in a text element with given id.
         * Insert a new text element below it.
         * @param {any} id
         */
  enterInTextElement(id) {

    var textElement = document.getElementById(id);
    if (textElement) {
      var div = textElement.firstElementChild.firstElementChild;
      var computedStyle = window.getComputedStyle(div);
      var x = div['offsetLeft'] + div.clientLeft;
      var y = div['offsetTop'] + div.clientTop;

      // Calculate default line space
      if (this.textLineSpaceTxt1 && this.textLineSpaceTxt2 && this.textLineSpace == null) {
        if (this.textLineSpaceTxt1.deleted != true && this.textLineSpaceTxt2.deleted != true) {
          this.textLineSpace = this.textLineSpaceTxt2.y - this.textLineSpaceTxt1.y;

          if (this.textLineSpace < 0 || this.textLineSpace > parseInt(computedStyle.height) * 5)
            this.textLineSpace = null;
        }
      }

      // Set vertical position
      if (this.textLineSpace == null)
        y += div['offsetHeight'];
      else
        y += this.textLineSpace;

      // Create new text object
      var identifier = id.split("_");
      var pos = parseInt(identifier[1]);
      this.textLineSpaceTxt1 = this.page.texts[pos];
      this.textLineSpaceTxt2 = this.textNew(x, y, true);
      this.textLineSpace = null;
    }
  }

  textFontSize(delta) {

    this.undoAction = this.UNDO_ACTION_NONE;
    if (this.selectedText === undefined) return;
    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
    if (this.selectedText) {
      if (delta > 0)
        this.selectedText.size += 2;
      else
        this.selectedText.size = (this.selectedText.size > 2 ? this.selectedText.size - 2 : 2);
      this.lastFontSize = this.selectedText.size;
    } else if (this.lastFontSize) {
      if (delta > 0)
        this.lastFontSize += 2;
      else
        this.lastFontSize = (this.lastFontSize > 2 ? this.lastFontSize - 2 : 2);
    }
  }

  activateLetterSpacing() {
    if (this.selectedText === undefined) return;
    this.textLetterSpacing(1);
    this.changeFontName('0');
  }

  deactivateLetterSpacing() {
    if (this.selectedText === undefined) return;
    this.selectedText.letterSpacing = 0;
    this.lastLetterSpacing = 0;
    this.changeFontName('2');
  }

  textLetterSpacing(delta) {

    var step = 2;
    this.undoAction = this.UNDO_ACTION_NONE;
    if (this.selectedText === undefined) return;
    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
    if (this.selectedText) {
      if (delta > 0)
        this.selectedText.letterSpacing += step;
      else
        this.selectedText.letterSpacing = (this.selectedText.letterSpacing >= step ? this.selectedText.letterSpacing - step : 0);
      this.lastLetterSpacing = this.selectedText.letterSpacing;
    } else if (this.lastLetterSpacing) {
      if (delta > 0)
        this.lastLetterSpacing += step;
      else
        this.lastLetterSpacing = (this.lastLetterSpacing >= step ? this.lastLetterSpacing - step : 0);
    }
  }

  textColor(colString) {
    this.undoAction = this.UNDO_ACTION_NONE;
    var color = parseInt(colString);
    this.lastFontColor = color;
    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
    if (this.selectedText)
      this.selectedText.color = color | 0;
  }

  onCursorBtnClicked() {
    this.stopEditingCurrentElement();
  }

  onInsertTextBtnClicked() {
    this.applyCanvas();
    this.openEraser(false);
    this.deselect();
    if (this.mode != this.MODE_INSERTING_TEXT)
      this.openSelectPoint(true, 'text');
    else
      this.cancelSelectPoint();
  }

  openSelectPoint(open: boolean = undefined, cursorType: any = undefined) {

    this.deselect();
    this.applyCanvas();
    this.selectPointActive = open;

    if (open) {
      var bg = document.getElementById('background');
      this.selectPointStyle = {
        display: 'inline',
        width: bg.offsetWidth + 'px',//['width'],
        height: bg.offsetHeight + 'px',//['height'],
        cursor: (cursorType ? cursorType : 'crosshair')
      };
      this.mode = (cursorType == 'text' ? this.MODE_INSERTING_TEXT : '');  // TODO: what are other scenarios?
    } else {
      this.selectPointStyle = { display: "none", cursor: "crosshair" };
      this.mode = this.MODE_IDLE;
    }
  }

  isTextElementUnderMouse(txt, x, y) {
    var r = txt.getBoundingClientRect();
    if (r) {
      if (r.x <= x && r.x + r.width >= x && r.y <= y && r.y + r.height >= y)
        return true;
    }
    return false;
  }

  selectPoint(p) {
    // Quit if we are dragging
    if (this.dragging) {
      return;
    }

    // If user clicked on an already existing text then select that text
    var txts = document.getElementsByClassName('abx-element-text');
    for (var i = 0; i < txts.length; i++) {
      if (this.isTextElementUnderMouse(txts[i], p[2], p[3])) {
        this.selectText(txts[i].parentElement.parentElement.id);
        return;
      }
    }

    // Add new text
    if (this.onSelectedTextLetterSpacingChangeInProgress === false) {
      this.textNew(p[0], p[1], true, true);
    }
  }

  cancelSelectPoint() {
    this.openSelectPoint(false);
  }

  changeFontStyle(bold, italic) {
    try {
      this.undoAction = this.UNDO_ACTION_NONE;
      if (bold > -1) {
        this.selectedText.bold = bold;
        this.lastFontStyle.bold = bold;
      }
      if (italic > -1) {
        this.selectedText.italic = italic;
        this.lastFontStyle.italic = italic;
      }

      this.markPageAsDirty();
      this.pageModified = true;
      this.pageModifiedElement = true;
    } catch (e) {
      this.logger.logInternalError("changeFontStyle", e.message);
    }

  }

  changeFontName(font) {
    this.undoAction = this.UNDO_ACTION_NONE;
    if (this.selectedText)
      this.selectedText.font = font;
    this.lastFontName = font;
    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
  }

  // ============
  // HANDLING PEN/MARKER ELEMENTS
  // ============

  markerColor(colString) {
    this.undoAction = this.UNDO_ACTION_NONE;
    var color = parseInt(colString);

    // Preserve the original alpha!
    var alpha = this.selectedMarker.inkColor & 0xFF000000;
    this.selectedMarker.inkColor = (alpha | color) | 0;
    if (this.selectedObj.elementIdentificator == 4)
      this.prevMarkerColor = this.selectedMarker.inkColor;
    else if (this.selectedObj.elementIdentificator == 3)
      this.prevPenColor = this.selectedMarker.inkColor;
    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
  }

  canvasColor(colString) {
    this.undoAction = this.UNDO_ACTION_NONE;
    var color = parseInt(colString);

    // Preserve the original alpha!
    var alpha = this.newMarkerColor & 0xFF000000;
    this.newMarkerColor = (alpha | color) | 0;
    if (this.mode == this.MODE_INSERTING_MARKER || this.mode == this.MODE_INSERTING_MARKER_START)
      this.prevMarkerColor = this.newMarkerColor;
    if (this.mode == this.MODE_INSERTING_PEN || this.mode == this.MODE_INSERTING_PEN_START)
      this.prevPenColor = this.newMarkerColor;
    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
  }

  markerLineWidth(delta) {

    this.undoAction = this.UNDO_ACTION_NONE;
    if (this.selectedMarker === undefined) return;

    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
    if (this.selectedMarker.elementIdentificator === 7) {
      // Scale signature
      if (delta > 0) {
        this.selectedMarker.scaleX *= 1.1;
        this.selectedMarker.scaleY *= 1.1;
      } else {
        this.selectedMarker.scaleX /= 1.1;
        this.selectedMarker.scaleY /= 1.1;
      }
    } else {
      // Change ink size for pen/marker
      this.selectedMarker.inkSize += delta;
    }
  }

  markerLineWidthAbs(width) {

    this.undoAction = this.UNDO_ACTION_NONE;
    if (this.selectedMarker === undefined) return;

    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
    var isPen = (this.selectedMarker.elementIdentificator === 3);

    // Change ink size
    this.selectedMarker.inkSize = width;

    if (isPen)
      this.lastPenWidth = this.deScaleMarkerWidth(this.selectedMarker.inkSize);
    else
      this.lastMarkerWidth = this.deScaleMarkerWidth(this.selectedMarker.inkSize);

    this.updateElementMoverPosition(this.selectedId);
  }

  canvasLineWidthAbs(width) {

    this.undoAction = this.UNDO_ACTION_NONE;
    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
    var isPen = (this.addPen === 3);

    // Change ink size
    this.newMarkerWidth = width;

    if (isPen)
      this.lastPenWidth = this.deScaleMarkerWidth(width);
    else
      this.lastMarkerWidth = this.deScaleMarkerWidth(width);
  }

  markerLineFixedWidth(width) {

    this.undoAction = this.UNDO_ACTION_NONE;
    if (this.selectedMarker === undefined) return;

    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
    var isPen = (this.selectedMarker.elementIdentificator === 3);

    // Change ink size
    if (width == 1)
      this.selectedMarker.inkSize = (isPen ? 1 : 5);
    else if (width == 2)
      this.selectedMarker.inkSize = (isPen ? 5 : 25);
    else if (width == 3)
      this.selectedMarker.inkSize = (isPen ? 10 : 50);
    else if (width == 4)
      this.selectedMarker.inkSize = (isPen ? 20 : 100);

    if (isPen)
      this.lastPenWidth = this.deScaleMarkerWidth(this.selectedMarker.inkSize);
    else
      this.lastMarkerWidth = this.deScaleMarkerWidth(this.selectedMarker.inkSize);

  }

  canvasLineWidth(delta) {
    this.undoAction = this.UNDO_ACTION_NONE;
    this.newMarkerWidth += delta;
  }

  canvasLineFixedWidth(width) {

    this.undoAction = this.UNDO_ACTION_NONE;
    var isPen = (this.addPen === 3);

    // Change ink size
    if (width == 1)
      this.newMarkerWidth = (isPen ? 1 : 5);
    else if (width == 2)
      this.newMarkerWidth = (isPen ? 5 : 25);
    else if (width == 3)
      this.newMarkerWidth = (isPen ? 10 : 50);
    else if (width == 4)
      this.newMarkerWidth = (isPen ? 20 : 100);

  }

  markerDelete() {

    try {
      this.undoAction = this.UNDO_ACTION_NONE;
      if (this.selectedId === undefined) return;
      var identifier = this.selectedId.split("_");
      if (identifier[0] !== "pmk") return;

      var pos = parseInt(identifier[1]);

      this.page.markers.splice(pos, 1);
      this.markPageAsDirty();
      this.pageModified = true;
      this.pageModifiedElement = true;

      this.deselect();
    } catch (e) {
      this.logger.logInternalError("PAGE: delete MARKER", e.message);
    }
  }

  // ============
  // HANDLING IMAGE SIGNATURES
  // ============

  importImageSignature() {
    try {
      this.imageSignatureTag.click();
    } catch (e) {
      this.logger.logInternalError('', e);
    }
  }

  addImageSignature() {

    try {
      this.undoAction = this.UNDO_ACTION_NONE;
      var file = this.imageSignatureTag.files[0];
      var reader = new FileReader();
      reader.addEventListener('load', () => {
        this.addImageSignatureWithImage(reader.result, file.type);
      });
      reader.readAsDataURL(file);
    } catch (e) {
      this.logger.logInternalError('', e);
    }

  }

  addImageSignatureWithImage(signature, imageType) {
    try {

      this.undoAction = this.UNDO_ACTION_NONE;
      var type = 0;
      if (imageType === "image/jpeg") {
        signature = signature.substring(23);
        type = 0;
      } else if (imageType === "image/png") {
        signature = signature.substring(22);
        type = 1;
      } else {
        this.logger.write2log("Unknown signature file!", '');
        this.dialogs.openMessageDialog(this.translateService.instant('Signature'), this.translateService.instant('UnsupportedFileFormat'));
        return;
      }

      this.imageSignatureTag.value = "";

      signature = {
        __type: "SwrdConverterLib.TWF.TwfSignatureImage, SwrdConverterLib.Core",
        x: 10,
        y: 10,
        scaleX: -1.0,
        scaleY: -1.0,
        type: 0,
        elementIdentificator: 8,
        selected: false,
        transparencyColor: 16777215,
        transparencyType: 0,
        image: signature
      };

      try {
        signature.y += Math.floor(document.getElementById("pagePlaceholder").scrollTop / this.scale);
      } catch (e) {
        this.logger.logInternalError('addImageSignatureWithImage', e.message);
      }

      this.ngZone.run(() => {
        this.markPageAsDirty();
        this.pageModified = true;
        this.pageModifiedElement = true;
        this.cropAllowed = false;
        var id = "sig_" + this.page.imageSignatures.length;
        this.page.imageSignatures.push(signature);
        this.selectImgSignature(id);
      });

    } catch (e) {
      this.logger.logInternalError('', e);
    }
  }

  imageSigScale(delta) {

    try {
      this.undoAction = this.UNDO_ACTION_NONE;
      if (this.selectedImgSignature === undefined) return;

      this.markPageAsDirty();
      this.pageModified = true;
      this.pageModifiedElement = true;
      if (delta > 0) {
        this.selectedImgSignature.scaleX *= 1.1;
        this.selectedImgSignature.scaleY *= 1.1;
      } else {
        this.selectedImgSignature.scaleX /= 1.1;
        this.selectedImgSignature.scaleY /= 1.1;
      }

      setTimeout(() => { this.updateElementMoverPosition(this.selectedId); }, 0);
    } catch (e) {
      this.logger.logInternalError("PAGE: imgsig scale", e.message);
    }

  }

  imageSigDelete() {

    try {
      this.undoAction = this.UNDO_ACTION_NONE;
      if (this.selectedId === undefined) return;

      var identifier = this.selectedId.split("_");
      if (identifier[0] !== "sig") return;

      var pos = parseInt(identifier[1]);

      this.page.imageSignatures.splice(pos, 1);
      this.markPageAsDirty();
      this.pageModified = true;
      this.pageModifiedElement = true;

      this.deselect();
    } catch (e) {
      this.logger.logInternalError("PAGE: deletect IMGSIG", e.message);
    }
  }

  // =================
  // INSERT IMAGE
  // =================
  async chooseImageToInsert() {
    var img = await this.dialogs.openSelectImageDialog(
      this.document,
      this.swrp,
      this.clientMode
    );

    if (img !== undefined) {
      this.addImageSignatureFromDialog(img, null, false);
    }
  }

  // =================
  // SAVED SIGNATURES
  // =================
  saveSignature(sig) {

    // Check if the user is logged in
    if (!this.userId) {
      this.dialogs.openMessageDialog(this.translateService.instant('Login'), this.translateService.instant('LoginBeforeSavingSignature')/*,
        () { doLogin(); }*/
      );
      return;
    }

    var signatureObject = this.selectedImgSignature ? this.selectedImgSignature : this.selectedMarker;

    if (signatureObject) {
      var signatureString = JSON.stringify(signatureObject);
      var description = this.signatureDescription;
      if (description === undefined || description.length === 0) description = this.translateService.instant('NewSignature');

      this.dialogs.openTextInputDialog(description, realDescription => {
        this.showLoaderWithMessage(this.translateService.instant('SavingSignature'));
        this.saveSignatureWithTitle(signatureString, realDescription);
      });
    }

  }

  saveSignatureWithTitle(signatureString, realDescription) {
    return this.signature.saveSignature(signatureString, realDescription).then(
      data => {
        this.signatureDescription = "";
        if (data === undefined) {
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('SignatureSaveError'));
        } else if (data['status'] === 401) {
          this.doLogin();
        } else if (data['status'] === 0) {
          this.loadSignatures();
        } else if (data['status'] === -3) {
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('Max3Signatures'));
        } else {
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('SignatureSaveError'));
        }
      }
    );
  }

  isLoadingSignatures() {
    if (this.loadingSignatures)
      return true;
    if (this.signature.isSignatureSaving())
      return true;
    if (this.signature.isSignatureDeleting())
      return true;

    return false;
  }

  showSignatureDropDownAndLoadSignatures() {
    //$('#signatures-toolbar .dropdown-toggle').dropdown('toggle');
    this.dropdown.open();
    this.loadSignatures();
  }

  loadSignatures() {

    // Open signatures dropdown
    this.loadingSignatures = true;

    // Download list of signatures from server
    this.signature.getSignatureList().then(
      data => {
        this.loadingSignatures = false;
        if (data === undefined) {
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('SignaturesLoadError'));
        } else if (data['status'] === 401) {
          this.doLogin();
        } else if (data['status'] !== 0) {
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('SignaturesLoadError'));
        } else {
          this.savedSignatures = data['signatures'];
        }
      }
    );
  }

  addNewSignature() {
    this.checkUserAndOpenSignatureDialog();
  }

  checkUserAndOpenSignatureDialog() {

    // If we have a timer, a dialog will be shown on timeout
    if (this.timer || this.loadingSignatures) {
      return;
    }

    // Check if the user is logged in
    if (!this.userId) {
      this.user.setOpenPopupAfterLogin(this.AFTER_SIGNIN_SHOW_SIGNATURE);
      this.doLogin();
      return;
    }

    // Get saved signatures
    this.loadingSignatures = true;
    this.signature.getSignatureList().then(
      data => {
        this.loadingSignatures = false;
        if (data === undefined) {
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('SignaturesLoadError'));
        } else if (data['status'] === 401) {
          this.doLogin();
        } else if (data['status'] !== 0) {
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('SignaturesLoadError'));
        } else {
          this.dialogs.openSelectSignatureDialog(
            data['signatures'],
            this.document,
            this.swrp,
            (id) => { this.loadSignature(id); },   // add the signature to the page
            (points, title, save) => { this.addPenSignatureFromDialog(points, title, save); },
            (img, title, save) => { this.addImageSignatureFromDialog(img, title, save); },
            (text, font, title, save) => { this.addTextSignatureFromDialog(text, font, title, save); }
          );
        }
      }
    );
  }

  loadSignature(id) {

    this.signature.getSignature(id).then(
      data => {
        if (data === undefined) {
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('SignatureLoadError'));
        } else if (data['status'] === 0) {
          this.ngZone.run(() => { this.addSignatureFromData(data); });
      } else if (data['status'] === 401) {
          this.doLogin();
        } else {
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('SignatureLoadError'));
        }
      }
    );
  }

  deleteSignature(signatureToDelete) {
    // Delete signature from the list
    for (var i = 0; i < this.savedSignatures.length; i++) {
      if (this.savedSignatures[i].id == signatureToDelete.id) {
        this.savedSignatures.splice(i, 1);
        break;
      }
    }

    // Delete on the server side
    this.signature.deleteSignature(signatureToDelete.id).then(
      data => {
        this.loadSignatures();
      }
    );
  }

  addPenSignatureFromDialog(points, title, save) {

    this.undoAction = this.UNDO_ACTION_NONE;
    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
    this.cropAllowed = false;

    var sig = {
      __type: "SwrdConverterLib.TWF.TwfPenMarkerSignaturePen, SwrdConverterLib.Core",
      bezierInts: points,
      elementIdentificator: 7,
      inkColor: 0xFF000000 | 0,
      inkSize: 4,
      scaleX: 1,
      scaleY: 1,
      selected: false,
      x: 10,
      y: 10
    };

    try {
      sig.y += Math.floor(document.getElementById("pagePlaceholder").scrollTop / this.scale);
    } catch (e) {
      this.logger.logInternalError('addImageSignatureFromDialog', e.message);
    }

    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
    this.cropAllowed = false;
    var id = "pmk_" + this.page.markers.length;

    try {
      var maxX = 0;
      var maxY = 0;
      var minX = Number.MAX_VALUE;
      var minY = Number.MAX_VALUE;

      for (var i = 0; i < points.length; i = i + 2) {
        maxX = Math.max(maxX, points[i]);
        minX = Math.min(minX, points[i]);
        maxY = Math.max(maxY, points[i + 1]);
        minY = Math.min(minY, points[i + 1]);
      }

      sig['width'] = (maxX - minX);
      sig['height'] = (maxY - minY);

      var sigWidth = sig['width'];
      var pageWidth = document.getElementById("background")['width'];
      var scale = pageWidth / (sigWidth * 5);
      sig.scaleX = scale;
      sig.scaleY = scale;

    } catch (e) {
      this.logger.logInternalError('addPenSignatureFromDialog-' + '-error while scaling', e);
    }

    this.ngZone.run(() => {
      this.page.markers.push(sig);
      this.selectPmk(id);
    });

    if (save) {
      var sigString = JSON.stringify(sig);
      this.saveSignatureWithTitle(sigString, title);
    }

  }

  addImageSignatureFromDialog(img, title, save) {

    this.undoAction = this.UNDO_ACTION_NONE;
    this.pageModified = true;
    this.pageModifiedElement = true;
    this.cropAllowed = false;

    var signature = {
      __type: "SwrdConverterLib.TWF.TwfSignatureImage, SwrdConverterLib.Core",
      x: 10,
      y: 10,
      scaleX: -1.0,
      scaleY: -1.0,
      type: 0,
      elementIdentificator: 8,
      selected: false,
      transparencyColor: 16777215,
      transparencyType: 0,
      image: img
    };

    try {
      signature.y += Math.floor(document.getElementById("pagePlaceholder").scrollTop / this.scale);
    } catch (e) {
      this.logger.logInternalError('addImageSignatureFromDialog', e.message);
    }


    this.pageModified = true;
    this.pageModifiedElement = true;
    this.cropAllowed = false;
    this.ngZone.run(() => {
      var id = "sig_" + this.page.imageSignatures.length;
      this.page.imageSignatures.push(signature);
      this.selectImgSignature(id);
    });

    if (save) {
      var sigString = JSON.stringify(signature);
      this.saveSignatureWithTitle(sigString, title);
    }
  }

  addTextSignatureFromDialog(text, font, title, save) {
    this.undoAction = this.UNDO_ACTION_NONE;
    this.signature.getImageForTextSignature(text, font).then(data => {

      if (data !== undefined && data['status'] === 0 && data['image'] !== undefined && data['image'].length > 0) {
        this.addImageSignatureFromDialog(data['image'], title, save);
      } else {
        this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotGenerateSignature'));
      }

    });
  }

  addSignatureFromData(data) {

    this.undoAction = this.UNDO_ACTION_NONE;
    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
    this.cropAllowed = false;

    var signature = data.signature;
    if (typeof (signature) !== 'string') signature = JSON.stringify(signature);
    if (typeof (signature) === 'string') signature = JSON.parse(signature);

    signature.selected = true;

    signature.x = 10;
    signature.y = 10;

    signature.isSignature = true;

    try {
      signature.y += Math.floor(document.getElementById("pagePlaceholder").scrollTop / this.scale);
      signature.x += Math.floor(document.getElementById("pagePlaceholder").scrollLeft / this.scale);
    } catch (e) {
      this.logger.logInternalError('signatureFromData', e.message);
    }

    if (signature.elementIdentificator === 8) {
      this.pageModified = true;
      this.pageModifiedElement = true;
      this.cropAllowed = false;
      var id = "sig_" + this.page.imageSignatures.length;
      this.page.imageSignatures.push(signature);
      setTimeout(() => this.selectImgSignature(id), 10)
    } else if (signature.elementIdentificator === 7) {
      this.pageModified = true;
      this.pageModifiedElement = true;
      this.cropAllowed = false;

      // Scale signature
      try {
        var sigWidth = signature.width;
        var pageWidth = document.getElementById("background").offsetWidth;
        var scale = pageWidth / (sigWidth * 5);
        signature.scaleX = scale;
        signature.scaleY = scale;
      } catch (e) {
        console.error(e);
      }

      this.markPageAsDirty();

      this.ngZone.run(() => {
        var id = "pmk_" + this.page.markers.length;
        this.page.markers.push(signature);
        this.selectPmk(id);
      });
    }
  }

  // =====================
  // VANAIA Account functions
  // =====================

  logout() {

    this.user.logout().then(
      data => {
        if (data !== undefined && data['status'] === 0) {
          this.user.saveUserId(null);
          this.userId = null;
          this.dialogs.openMessageDialog(this.translateService.instant('Ok'), this.translateService.instant('LogoutOk'));
        } else this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorLogout'));
      }
    );

  }

  changeAccount() {

    this.user.logout().then(
      data => {
        if (data !== undefined && data['status'] === 0) this.doLogin();
        else this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorLogout'));
      }
    );

  }

  doLogin(dontStopEditing: any = undefined, applyScope: any = undefined) {

    if (applyScope) {
      //$scope.$apply();
      this.ngZone.run(() => { });
    }

    if (dontStopEditing != true) {
      this.addPenMarker(this.penMakerPoints, this.mode);
      this.stopEditingCurrentElement();
      setTimeout(() => { this.doLogin(true, applyScope) }, 0);
      return;
    }

    if (this.pageModified) {
      this.save().then(
        data => {
          this.goToLoginPage();
        }
      );
    } else {
      this.goToLoginPage();
    }

  }

  goToLoginPage() {
    var l = wrapperGetNativeLogin();
    if (wrapperGetNativeLogin()) {

      var currentPath = this.location.path();// undefined /*= location.path();*/
      var currentSearch = window.location.search;// undefined /*= location.search();*/
      var state = "s" + Math.floor(Math.random() * 1000000);

      this.user.saveCurrentPath(currentPath, currentSearch, state);
      this.user.setOpenPopupAfterLogin(null);

      wrapperRequestNativeLogin(userId => {
        this.logger.write2log("requestNativeLogin", "received native login for " + userId, "P");
        this.ngZone.run(() => {
          this.user.saveUserId(userId);
          this.userId = userId;
          this.showSignatureDropDownAndLoadSignatures();
        });
      });
    } else {
      this.user.getLoginPage(wrapperGetSiteLanguage(), wrapperGetSiteVersion(), wrapperGetSiteLogo()).then(
        data => {
          if (data['status'] === 0) {

            var loginUrl = data['loginUrl'];

            //TODO path
            var currentPath = window.location.href; //this.router.url;
            var currentSearch = window.location.search; //undefined; /*this.location.search();*/
            var state = "s" + Math.floor(Math.random() * 1000000);

            this.user.saveCurrentPath(currentPath, currentSearch, state);

            var stateString = wrapperGetSiteLanguage() + ":" + wrapperGetSiteVersion() + ":" + wrapperGetSiteLogo() + ":" + state;
            
            let navigateUrl = loginUrl + "&state=" + stateString + "&apple_login=" + (this.clientMode ? "yes" : "no");
            window.location.assign(navigateUrl);
            //console.log('Test navigateUrl', navigateUrl)
          }
        }
      );
    }
  }

  // ============
  // CANVAS EDITOR
  // ============

  cancelCanvasEditor() {
    this.editingCancelled = true;

    try {
      if (this.canvasEditorOpen === true) {
        this.canvasEditorOpen = false;
        this.canvasStyle = { display: 'none' };
      }
    } catch (e) {
      this.logger.logInternalError("PAGE: canvas editor", e.message);
    }
  }

  scaleMarkerWidth(width) {
    return Math.ceil(width / this.scale);
  }

  deScaleMarkerWidth(width) {
    return Math.ceil(width * this.scale);
  }

  closeCanvasEditor() {
    try {
      this.penMakerPoints = [];
      this.canvasEditorOpen = false;
      this.canvasStyle = { display: 'none' };
    } catch (e) {
      this.logger.logInternalError("PAGE: closeCanvasEditor", e.message);
    }
  }

  openCanvasEditor(type: any = undefined, switchToNewPenType: any = undefined, dontCheckForEraserMode: any = undefined) {

    this.editingCancelled = false;

    if (this.mode == this.MODE_INSERTING_TEXT) this.cancelSelectPoint();
    if (this.mode == this.MODE_ERASING && !dontCheckForEraserMode) {
      this.openEraser(false);
      setTimeout(() => { this.openCanvasEditor(type, false, true); }, 0);
      return;
    }

    try {
      var newMode = null;
      if (type == 3)
        newMode = this.MODE_INSERTING_PEN_START;
      else if (type == 4)
        newMode = this.MODE_INSERTING_MARKER_START;
      else if (type == 7)
        newMode = this.MODE_INSERTING_SIGNATURE_PEN_START;

      if (this.mode === newMode) {
        return;
      } else {

        if (!switchToNewPenType && (this.mode == this.MODE_INSERTING_PEN || this.mode == this.MODE_INSERTING_MARKER)) {
          this.applyCanvas();
          setTimeout(() => { this.openCanvasEditor(type, true); }, 0);
          return;
        }

        this.addPen = type;
        this.canvasEditorOpen = true;
        this.mode = newMode;
        this.deselect();

        var width;

        if (type === 7) {
          // signature
          this.newMarkerColor = 0xFF000000;
          this.newMarkerWidth = this.scaleMarkerWidth(5);
        } else if (type === 3) {
          // pen style
          if (this.prevPenColor != null)
            this.newMarkerColor = this.prevPenColor;
          else
            this.newMarkerColor = 0xFF000000;
          width = this.lastPenWidth === 0 ? 5 : this.lastPenWidth;
          this.newMarkerWidth = this.scaleMarkerWidth(width);
          this.selectedMarkerInkSize = this.newMarkerWidth;
        } else {
          // marker
          if (this.prevMarkerColor != null)
            this.newMarkerColor = this.prevMarkerColor;
          else
            this.newMarkerColor = this.grayscale ? 0x99999999 : 0x99FFFF00;
          width = this.lastMarkerWidth === 0 ? 50 : this.lastMarkerWidth;
          this.newMarkerWidth = this.scaleMarkerWidth(width);
          this.selectedMarkerInkSize = this.newMarkerWidth;
        }

        var bg = document.getElementById('background');
        this.canvasStyle = {
          display: 'inline',
          width: bg['width'],
          height: bg['height']
        };
      }
    } catch (e) {
      this.logger.logInternalError("PAGE: canvaseditor", e.message);
    }
  }

  applyCanvas() {
    this.closeCanvasEditor();
  }

  translatePenMarkerPoints(points) {

    var minX = Number.MAX_VALUE, minY = Number.MAX_VALUE, i = 0, j = 0;


    for (i = 0; i < points.length - 1; i = i + 2) {
      minX = Math.min(minX, points[i]);
      minY = Math.min(minY, points[i + 1]);
    }

    for (i = 0; i < points.length - 1; i = i + 2) {
      points[i] -= minX;
      points[i + 1] -= minY;
    }

    return { points: points, x: minX, y: minY };
  }

  updatePenMaketPoints(points) {
    this.penMakerPoints = this.penMakerPoints.concat(points.points);
  }

  addPenMarker(points, mode: string = '') {
    if (mode == this.MODE_INSERTING_TEXT) {
      this.selectedTextIsNew = false;
    }

    if (mode == this.MODE_INSERTING_SIGNATURE_PEN) return;

    if (this.editingCancelled) return;
    if (this.addPen === undefined) return;
    if (points === undefined || points.length === 0) return;

    points = this.translatePenMarkerPoints(points);

    try {
      var id = this.addPen;
      var markerColor = this.newMarkerColor;
      var color = id === 4 ? markerColor : this.newMarkerColor;
      var width = this.newMarkerWidth;

      if (id === 3) {
        // pen
        this.lastPenWidth = this.deScaleMarkerWidth(width);
      } else if (id === 4) {
        // marker
        this.lastMarkerWidth = this.deScaleMarkerWidth(width);
      }

      this.markPageAsDirty();
      this.pageModified = true;
      this.pageModifiedElement = true;
      this.cropAllowed = false;

      this.page.markers.push({
        __type: "SwrdConverterLib.TWF.TwfPenMarkerSignaturePen, SwrdConverterLib.Core",
        bezierInts: points.points,
        elementIdentificator: id,
        inkColor: color | 0,
        inkSize: width,
        scaleX: 1,
        scaleY: 1,
        selected: false,
        x: points.x,
        y: points.y
      });


    } catch (e) {
      this.logger.logInternalError("PAGE: canvaseditor", e.message);
    }
  }

  onCanvasDrawStart() {
    try {
      this.markPageAsDirty();

      this.pageModified = true;
      this.pageModifiedElement = true;

      if (this.mode == this.MODE_INSERTING_PEN_START)
        this.mode = this.MODE_INSERTING_PEN;
      else if (this.mode == this.MODE_INSERTING_MARKER_START)
        this.mode = this.MODE_INSERTING_MARKER;
      else if (this.mode == this.MODE_INSERTING_SIGNATURE_PEN_START)
        this.mode = this.MODE_INSERTING_SIGNATURE_PEN;

      this.undoAction = this.UNDO_ACTION_NONE;

    } catch (e) {
      this.logger.logInternalError("PAGE: onCanvasDrawStart", e.message);
    }
  }

  // ============
  // ERASER
  // ============

  revertEraser() {

    if (this.mode == this.MODE_ERASING) {
      this.cancelEraser();
      setTimeout(() => { this.stopEditingCurrentElement(); }, 0);
    }
    if (this.initialBackground)
      this.page.background.image = this.initialBackground;
    this.undoAction = this.UNDO_ACTION_NONE;

  }

  cancelEraser() {
    this.editingCancelled = true;

    try {

      this.hideEraserWithTimeout();
      this.eraserActive = false;

    } catch (e) {
      this.logger.logInternalError("PAGE: eraser", e.message);
    }
  }

  openEraser(open) {
    try {

      this.deselect();

      if (this.initialBackground === undefined && this.page && this.page.background) this.initialBackground = this.page.background.image;
      this.editingCancelled = false;

      if (open) {
        if (this.clientMode) {
          this.startUsingEraserTool();
          this.eraserActive = open;
        }
        else {
          if (this.userId) {
            this.user.hasSubscription(false, true).then(
              data => {
                if (data['status'] == 1) {
                  this.startUsingEraserTool();
                } else {
                  this.storeid = data['id'];
                  this.storehash = data['hash'];
                  this.saveAndDoShowUpgradeOptions(this.UPGRADE_USE_ERASER);
                }
              }
            );
          } else {
            this.saveAndDoShowSubscriptionDialog(-1, '', this.UPGRADE_USE_ERASER);
          }
        }
      } else {
        this.hideEraserWithTimeout();
        this.eraserActive = false;
      }
    } catch (e) {
      this.logger.logInternalError("PAGE: eraser", e.message);
    }
  }

  startUsingEraserTool() {
    try {
      this.applyCanvas();
      this.cancelSelectPoint();
      this.clearEraserHideTimeout();

      var bg = document.getElementById('background');
      this.eraserStyle = {
        display: 'inline',
        width: bg['width'],
        height: bg['height']
      };

      this.eraserActive = true;
      this.mode = this.MODE_ERASING;
    } catch (e) {
      this.logger.logInternalError("PAGE: eraser", e.message);
    }
  }

  saveEraser(image) {
    if (this.page.filters === undefined) {
      this.page.filters = []
    }

    if (this.editingCancelled) return;

    try {
      if (this.page) {
        var pos = image.image.search(',');
        this.page.background.image = image.image.substring(pos + 1);
        this.markPageAsDirty();
        this.pageModified = true;
        this.pageModifiedElement = true;
        this.backgroundWasModified = true;

        this.page.filters.push({
          __type: "SwrdConverterLib.TWF.TwfRotate, SwrdConverterLib.Core",
          elementIdentificator: 12,
        });

        // Temporarily hide eraser cursor until eraser hide timeout kicks in.
        this.hideEraserWithTimeout();

        this.cdref.detectChanges();
      }
    } catch (e) {
      this.logger.logInternalError("PAGE: eraser", e.message);
    }

  }

  // Radirko skrijemo z 250ms zamikom. Sicer se na Firefoxu pojavi problem, ker radirka po koncu
  // uporabe za kratek čas zgine (blendne) ter se nato spet pojavi. To je posledica problema, da
  // Firefox z zamikom ažurira sliko in najprej skrije radirko nato pa šele prikaže poažurirano
  // sliko z poradiranimi deli.
  hideEraserWithTimeout() {
    this.clearEraserHideTimeout();
    this.eraserStyle.cursor = 'default';
    this.eraserHideTimeout = setTimeout(() => { this.eraserStyle = { display: 'none' }; }, 250);
  }

  erasingStarted() {
    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
    if (this.undoAction != this.UNDO_ACTION_ERASER) {
      this.initialBackground = this.page.background.image;
      this.undoAction = this.UNDO_ACTION_ERASER;
    }
  }

  setEraserInWidthAccordingToScale(scale) {
    // Eraser's size should always be the same relative to the zoom
    var w = Math.ceil(20 / scale);
    if (w < 1)
      w = 1;
    this.eraserInkWidth = w;
  }

  // ============
  // MOVING ELEMENTS
  // ============

  moveElementBy($abxEltId, $abxDiffX, $abxDiffY) {
    try {
      this.undoAction = this.UNDO_ACTION_NONE;
      var identifier = $abxEltId.split("_");
      var elements = undefined;
      switch (identifier[0]) {
        case "pmk":
          elements = this.page.markers;
          break;
        case "txt":
          elements = this.page.texts;
          break;
        case "sig":
          elements = this.page.imageSignatures;
      }

      if (elements === undefined) return;

      var pos = parseInt(identifier[1]);

      var elt = elements[pos];
      elt.selected = true;

      try {
        var diffX = parseInt($abxDiffX);
        var diffY = parseInt($abxDiffY);
      } catch (e) {
        return;
      }

      var newX = elt.x + diffX;
      var newY = elt.y + diffY;

      var e = document.getElementsByClassName('selected-element')[0];
      var b = document.getElementById('background');

      if (e && b) {
        var eWidth = e.scrollWidth;
        var eHeight = e.scrollHeight;
        if ((newX + eWidth) > b.scrollWidth)
          newX = (b.scrollWidth - eWidth);
        if ((newY + eHeight) > b.scrollHeight)
          newY = (b.scrollHeight - eHeight);
      }

      elt.x = Math.max(newX, 0);
      elt.y = Math.max(newY, 0);

      this.updateElementMoverPosition($abxEltId);
      this.markPageAsDirty();
      this.pageModified = true;
      this.pageModifiedElement = true;
    } catch (e) {
      this.logger.logInternalError("PAGE: moveElementBy", e.message);
    }
  }

  moveElement($abxEltId, $abxPosX, $abxPosY) {

    try {
      this.undoAction = this.UNDO_ACTION_NONE;
      if ($abxPosX < 0)
        $abxPosX = 0;
      if ($abxPosY < 0)
        $abxPosY = 0;

      var elt = null;
      if ($abxEltId == 'elementMoverCursor') {
        $abxEltId = this.selectedId;
        elt = this.selectedObj;
      } else {
        var identifier = $abxEltId.split("_");
        var elements = undefined;
        switch (identifier[0]) {
          case "pmk":
            elements = this.page.markers;
            break;
          case "txt":
            elements = this.page.texts;
            break;
          case "sig":
            elements = this.page.imageSignatures;
        }

        if (elements === undefined) return;
        var pos = parseInt(identifier[1]);
        elt = elements[pos];
      }

      try {
        var e = document.getElementsByClassName('selected-element')[0];
        var b = document.getElementById('background');
        var newX = parseInt($abxPosX);
        var newY = parseInt($abxPosY);
        if (e && b) {
          var eWidth = e.scrollWidth;
          var eHeight = e.scrollHeight;
          if ((newX + eWidth) > b.scrollWidth)
            newX = (b.scrollWidth - eWidth);
          if ((newY + eHeight) > b.scrollHeight)
            newY = (b.scrollHeight - eHeight);
        }
      } catch (e) {
        this.logger.logInternalError("PAGE: moveElement", e.message);
      }

      elt.x = newX;
      elt.y = newY;
      this.updateElementMoverPosition($abxEltId);
      this.markPageAsDirty();
      this.pageModified = true;
      this.pageModifiedElement = true;
    } catch (e) {
      this.logger.logInternalError("PAGE: moveElement", e.message);
    }
  }

  moveElementEnd($abxEltId: any = undefined, $abxPosX: any = undefined, $abxPosY: any = undefined) {
    try {

      if ($abxEltId == 'elementMoverCursor')
        $abxEltId = this.selectedId;

      if (($abxEltId + '').indexOf('txt_') == 0) {
        var txtDOMObj = document.getElementById($abxEltId);
        txtDOMObj.children[0].dispatchEvent(new Event('click'));
      }

    } catch (e) {
      this.logger.logInternalError("PAGE: moveElementEnd", e.message);
    }
  }

  deselectAllTexts() {
    try {
      if (window.getSelection) {
        if (window.getSelection().empty) {  // Chrome
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {  // Firefox
          window.getSelection().removeAllRanges();
        }
      } else if (document['selection']) {  // IE?
        document['selection'].empty();
      }

    } catch (e) {
      this.logger.logInternalError("PAGE: deselectAllTexts", e.message);
    }
  }

  eventFire(el, etype) {
    if (el.fireEvent) {
      el.fireEvent('on' + etype);
    } else {
      var evObj = document.createEvent('Events');
      evObj.initEvent(etype, true, false);
      el.dispatchEvent(evObj);
    }
  }

  updateElementMoverPosition(relatedToObj) {
    if (relatedToObj === undefined || relatedToObj === null)
      return;

    var identifier = relatedToObj.split("_");
    var elements = undefined;
    var isImageSignature = false;
    switch (identifier[0]) {
      case "pmk":
        elements = this.page.markers;
        break;
      case "txt":
        elements = this.page.texts;
        break;
      case "sig":
        elements = this.page.imageSignatures;
        isImageSignature = true;
    }

    if (elements === undefined) return;
    var pos = parseInt(identifier[1]);
    var elt = elements[pos];

    var xOffset = 4;

    this.elementMoverButtonsContainer.style.left = ((elt.x * this.scale) - xOffset) + 'px';
    this.elementMoverButtonsContainer.style.top = ((elt.y * this.scale) - 35) + 'px';

    if (isImageSignature && elt.cssStyle) {
      var w = elt.cssStyle.width;
      if (w.endsWith('px'))
        w = w.substring(0, w.length - 2);
      var h = elt.cssStyle.height;
      if (h.endsWith('px'))
        h = h.substring(0, h.length - 2);
      w = parseFloat(w);
      h = parseFloat(h);
      this.elementResizer.style.left = ((elt.x + w) * this.scale + 2) + 'px';
      this.elementResizer.style.top = ((elt.y + h) * this.scale + 2) + 'px';
    }
  }

  // =================
  // IMAGE SIGNATURE SCALE CHANGED
  // =================
  onSelectedImageSignatureScaleChanged() {
    this.updateElementMoverPosition(this.selectedId);
    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
  }

  onSelectedSignatureStyleChanged() {
    this.updateElementMoverPosition(this.selectedId);
    this.markPageAsDirty();
    this.pageModified = true;
    this.pageModifiedElement = true;
  }

  // =================
  // TEXT LETTER SPACING CHANGING
  // =================
  onSelectedTextLetterSpacingChangeStart() {
    this.onSelectedTextLetterSpacingChangeInProgress = true;
  }

  onSelectedTextLetterSpacingChange() {
    this.lastLetterSpacing = this.selectedText.letterSpacing;
    this.pageModified = true;
    this.pageModifiedElement = true;
  }

  onSelectedTextLetterSpacingChangeEnd() {
    this.timeOutIsFromLetterSpacing = setTimeout(() => { this.onSelectedTextLetterSpacingChangeInProgress = false; }, 0);
  }


  // =================
  // RESIZING
  // =================
  startResizingSelectedPmk() {
    this.selectedPmkOriginalSize = [this.selectedObj.width, this.selectedObj.height, this.selectedObj.scaleX, this.selectedObj.scaleY];
  }

  resizeSelectedPmk(absX, absY) {
    this.undoAction = this.UNDO_ACTION_NONE;
    var diffX = ((this.selectedPmkOriginalSize[0] * this.selectedPmkOriginalSize[2]) - this.selectedPmkOriginalSize[0]) + absX;
    var diffY = ((this.selectedPmkOriginalSize[1] * this.selectedPmkOriginalSize[3]) - this.selectedPmkOriginalSize[1]) + absY;

    var targetW = this.selectedPmkOriginalSize[0] + diffX;
    var targetH = this.selectedPmkOriginalSize[1] + diffY;

    var targetScaleX = targetW / this.selectedPmkOriginalSize[0];
    var targetScaleY = targetH / this.selectedPmkOriginalSize[1];
    var targetScale = Math.max(targetScaleX, targetScaleY);

    this.selectedObj.scaleX = targetScale;
    this.selectedObj.scaleY = targetScale;
  }

  // =================
  // Mouse drag handlers
  // =================
  // we add a mouse move listener to <BODY> and
  // on mouse move we move the selected element.

  translateEventPoint(ev) {

    var page = $("#background");

    var touchEvents = 'ontouchstart' in document.documentElement;

    var clientX = touchEvents ? ev.touches[0].clientX : ev.clientX;
    var clientY = touchEvents ? ev.touches[0].clientY : ev.clientY;
    var pageX = page.offset().left;
    var pageY = page.offset().top;

    var x = (clientX - pageX) / this.scale;
    var y = (clientY - pageY) / this.scale;

    return { x: x, y: y };
  }
  
  initMouseMoveHandler(add: boolean = true) {

    var body = $("#pagePlaceholder");
    var touchEvents = 'ontouchstart' in document.documentElement;
    if (add !== false) {

      if (touchEvents) {
        body.on("touchstart", e => { this.ngZone.run(() => { this.handleMouseDown(e); }); });
        body.on("touchmove", e => { this.ngZone.run(() => { this.handleMouseMove(e); }); });
        body.on("touchend", e => { this.ngZone.run(() => { this.handleMouseUp(e); }); });
        body.on("touchcancel", e => { this.ngZone.run(() => { this.handleMouseUp(e); }); });
      } else {
        body.on("mousedown", e => { this.ngZone.run(() => { this.handleMouseDown(e); }); });
        body.on("mouseup", e => { this.ngZone.run(() => { this.handleMouseUp(e); }); });
        body.on("mousemove", e => { this.ngZone.run(() => { this.handleMouseMove(e); });
        });
      }
    } else {
      if (touchEvents) {
        body.off("touchstart");
        body.off("touchmove");
        body.off("touchend");
        body.off("touchcancel");
      } else {
        body.off("mousemove");
        body.off("mouseup");
        body.off("mousemove");
      }
    }
  }

  handleMouseMove(ev) {
    if (this.mouseDown && this.selectedObj) {
      if (ev.target.id === "lineWidthRange") return;

      ev.preventDefault();
      var point = this.translateEventPoint(ev);

      var diffX = point.x - this.mouseDownPoint.x;
      var diffY = point.y - this.mouseDownPoint.y;
      this.moveElementBy(this.selectedId, diffX, diffY);

      this.pageModifiedPosition = true;
      this.mouseDownPoint = point;
      this.dragging = true;

    }
  }

  handleMouseDown(ev) {
    // Don't handle dragging in text elements
    if (ev.target.attributes.contentEditable !== undefined) return;
    if (ev.target.id === "pagePlaceholder") return;
    if (ev.target.id === "background" && ev.target.classList && ev.target.classList.contains('backgroundImage')) return;
    if (ev.target.classList && ev.target.classList.contains('abx-donot-dragndrop')) return;
    this.mouseDownPoint = this.translateEventPoint(ev);
    this.pageModifiedPosition = false;
    this.mouseDown = true;
  }

  handleMouseUp(ev) {
    this.pageModifiedPosition = false;
    this.mouseDown = false;
    this.dragging = false;
    if (ev.target.id === "pagePlaceholder") this.deselectAllTexts();
    if (this.selectedId.indexOf('txt_') != 0) this.deselectAllTexts();    
    this.moveElementEnd(this.selectedId);
  }

  // =================
  // ZOOMING
  // =================

  zoom(delta) {

    try {
      this.deselect();
      this.addPenMarker(this.penMakerPoints, this.mode);
      this.stopEditingCurrentElement();

      var p = document.getElementById('page') as HTMLElement;
      if (p !== null) {

        var blur = 0.0;

        if (delta > 0)
          this.scale *= 1.1;

        else
          this.scale *= 0.9;

        if (this.scale > 1.0)
          blur = 1.0;
        else
          blur = (((1.0 / this.scale) - 1.0) / 2.0);

        p.style.transform = 'scale(' + this.scale + ')';

        var elements = p.children;
        for (var i = 0; i < elements.length; i++) {
          //TODO PREVERI STYLE WEBKITFILTER
          //elements[i].style.webkitFilter = 'blur(' + blur + ')';
          this.renderer.setStyle(elements[i], 'blur', blur);
        }

        this.horizontallyPositionPage();
        this.updateDynamicStyles(this.scale);
        this.setEraserInWidthAccordingToScale(this.scale);
      }
    } catch (e) {
      this.logger.logInternalError("PAGE: zoom", e.message);
    }
  }

  updateDynamicStyles(scale) {
    var styles = document.getElementById('dynamicStyles');
    if (styles) {
      var s2px = (2 / scale);
      var s3px = (3 / scale);
      var s = ".abx-element:not(.selected-element):hover { border-width: " + s2px + "px !important; margin: -" + s2px + "px !important; }\n" +
        ".selected-element { border-width: " + s3px + "px !important; margin: -" + (s3px) + "px !important; }";
      styles.innerHTML = s;
    }
  }

  zoomToScale(scale) {

    try {
      var p = document.getElementById('page') as HTMLElement;
      if (p !== null) {

        var blur = 0.0;

        this.scale = scale;
        this.updateDynamicStyles(scale);
        this.setEraserInWidthAccordingToScale(scale);

        if (scale > 1.0)
          blur = 1.0;
        else
          blur = (((1.0 / this.scale) - 1.0) / 2.0);

        p.style.transform = 'scale(' + this.scale + ')';

        var elements = p.children;
        for (var i = 0; i < elements.length; i++) {
          //TODO PREVERI STYLE WEBKITFILTER
          //elements[i].style.webkitFilter = 'blur(' + blur + ')';
          this.renderer.setStyle(elements[i], 'blur', blur);
        }
      }
    } catch (e) {
      this.logger.logInternalError("PAGE: zoomToScale", e.message);
    }
  }

  showLoaderWithMessage(message) {
    this.loaderMessage = message;
    this.showLoader = true;

  }

  hideLoaderWithMessage() {
    this.showLoader = false;
  }

  // ====================
  // PINCH TO ZOOM
  // ====================
  pinchToZoomStart() {
    this.initZoomToPinchScale = this.scale;
  }

  pinchToZoom(initDiff, initPosX, initPosY, curDiff) {
    var origSizeOfInitDiff = initDiff / this.initZoomToPinchScale;
    var currScale = curDiff / origSizeOfInitDiff;
    this.zoomToScale(currScale);
  }

  // ====================
  // EDITING SELECTION
  // ====================

  deleteSelection() {

    this.undoAction = this.UNDO_ACTION_NONE;
    if (this.selectedId === undefined) return;

    var identifier = this.selectedId.substring(0, 3);
    if (identifier === "pmk") this.markerDelete();
    else if (identifier === "sig") this.imageSigDelete();
    else if (identifier === "txt") this.textDelete();

  }

  scaleSelection(delta) {

    this.undoAction = this.UNDO_ACTION_NONE;
    if (this.selectedId === undefined) return;

    var identifier = this.selectedId.substring(0, 3);

    if (identifier === "sig") this.imageSigScale(delta);
    else if (identifier === "txt") this.textFontSize(delta);
    else if (identifier === "pmk") this.markerLineWidth(delta);
  }

  // ====================
  // GLOBAL EVENT HANDLING
  // ====================

  isModalOpen() {
    var mOpen = document.getElementsByClassName('modal-open');
    if (mOpen && mOpen.length > 0) {
      return true;
    }
    return false;
  }

  // =================================
  // STORE
  // =================================
  /**
   * Registers store callbacks. Callbacks are received from outside of angular.
   * @param {any} reg
   */
  registerCallbacks(reg) {
    try {
      wrapperRegisterWebhookCallback(reg === true ? (event) => this.webhookCallback(event) : undefined);
      wrapperRegisterCloseCallback(reg === true ? (event) => this.closeCallback(event) : undefined);
      if (reg) {
        this.logger.write2log('registerCallbacks', 'Registered payment callbacks', 'P');
      }
      else
        this.logger.write2log('registerCallbacks', 'UNRegistered payment callbacks', 'P');
    } catch (e) {
      this.logger.logInternalError('PAGE: registerCallbacks', e.message);
    }
  }

  saveAndDoShowUpgradeOptions(type: any = undefined, dontStopEditing: any = undefined) {
    try {
      if (dontStopEditing != true) {
        this.stopEditingCurrentElement();
        setTimeout(() => { this.saveAndDoShowUpgradeOptions(type, true) }, 0);
        return;
      }

      if (this.pageModified) {
        this.save(true).then(() => {
          this.doShowUpgradeOptions(type);
        });
      } else {
        this.doShowUpgradeOptions(type);
      }
    } catch (e) {
      this.logger.logInternalError('saveAndDoShowUpgradeOptions', e.message);
    }
  }

  doShowUpgradeOptions(type: any = undefined) {
    try {
      //if (onInit === 1) return;

      if (type != undefined) {
        if (type === this.UPGRADE_DOWNLOAD_SEARCHABLE_PDF) {
          this.user.setUpgradeStrings(this.translateService.instant('UpgradeAndDownloadSearchablePDF'), (this.translateService.instant('UpgradeAndDownloadPDFDesc2')));
        }
        else if (type === this.UPGRADE_DOWNLOAD_PDF) {
          this.user.setUpgradeStrings(this.translateService.instant('UpgradeAndDownloadPDFOrExportPNG'), (this.translateService.instant('UpgradeAndDownloadPDFDesc2')));
        }
        else {
          this.user.setUpgradeStrings(this.translateService.instant('UpgradeAndStartUsingEraser'), (this.translateService.instant('UpgradeAndDownloadPDFDesc2')));
        }

        var actionAfterOrderComplete = (type === this.UPGRADE_USE_ERASER ? this.AFTER_ORDER_COMPLETE_START_ERASER_TOOL : this.AFTER_ORDER_COMPLETE_DOWNLOAD_PDF);
        this.user.setActionAfterOrderComplete(actionAfterOrderComplete);
      } else {
        this.user.setActionAfterOrderComplete(this.AFTER_ORDER_COMPLETE_DO_NOTHING);
      }

      if (this.userId) {

        var strings = this.user.getUpgradeStrings();

        this.upgradeDialogTitle = strings.title;
        this.upgradeDialogDescription = strings.description;

        this.showSubscriptionDialog = false;

        this.upgradeOptions = [];
        this.upgradeOptions.push({
          price: document.getElementById('dataPriceScanWritrSubscription1d').innerText
        });
        this.upgradeOptions.push({
          price: document.getElementById('dataPriceScanWritrSubscription1m').innerText
        });
        this.upgradeOptions.push({
          price: document.getElementById('dataPriceScanWritrSubscription12m').innerText
        });

        this.currentlyOpenedUpgradeWindowReason = type;
        this.getSubscriptionInfo();
        this.showUpgradeOptions = true;
      } else {
        if (this.user.getActionAfterOrderComplete() === this.AFTER_ORDER_COMPLETE_START_ERASER_TOOL) {
          this.startSignIn(this.AFTER_SIGNIN_START_ERASER_TOOL);
        } else {
          this.startSignIn(this.AFTER_SIGNIN_START_SUBSCRIPTION_PURCHASE);
        }
      }
    } catch (e) {
      this.logger.logInternalError('PAGE: registerCallbacks', e.message);
    }
  }

  getSubscriptionInfo() {
    try {
      this.updatingSubscriptionInfo = true;
      this.user.getSubscriptionInfo(document.getElementById('dataPriceDefaultCountry').innerText, document.getElementById('dataPriceDefaultCurrency').innerText).then(
        (data) => {
          this.storeid = data["id"];
          this.storehash = data["hash"];
          this.subscriptionInfo = data;
          this.updatingSubscriptionInfo = false;
        }
      );

    } catch (e) {
      this.logger.logInternalError('PAGE: getSubscriptionInfo', e.message);
    }
  }

  doHideUpgradeOptionsDialog() {
    this.showUpgradeOptions = false;
  }

  startPurchaseProcess(sku, payload, key) {
    try {
      this.showUpgradeOptions = false;
      if (this.userId) {
        // User is known, start with purchase process ...
        this.user.setOpenPopupAfterLogin(null);
        this.doHideSubscriptionDialog();

        if (this.storeid == -1 || this.storehash == '') {
          this.logger.logInternalError('PAGE: startPurchaseProcess' + 'storeid = ' + this.storeid + ', storehash = ' + this.storehash, undefined);
          return;
        }

        this.user.setSkuToLookAfterOrderComplete(sku);

        wrapperFastspring.builder.clean();
        wrapperFastspring.builder.secure(payload, key);
        wrapperFastspring.builder.checkout();
      } else {
        // User is not known. Begin with sign in process ...
        if (this.user.getActionAfterOrderComplete() === this.UPGRADE_USE_ERASER) {
          this.startSignIn(this.AFTER_SIGNIN_START_ERASER_TOOL);
        } else {
          this.startSignIn(this.AFTER_SIGNIN_START_SUBSCRIPTION_PURCHASE);
        }
      }
    } catch (e) {
      this.logger.logInternalError('PAGE: startPurchaseProcess', e.message);
    }
  }

  /**
         * Starts sign in process.
         */
  startSignIn(doWhatAfterSignIn) {
    this.user.setOpenPopupAfterLogin(doWhatAfterSignIn);
    this.doLogin();
  }

  webhookCallback(event) {
    //$scope.$apply => { processWebhookEvent(event); };
    this.ngZone.run(() => { this.processWebhookEvent(event); });
  }

  processWebhookEvent(event) {
    this.orderCompleted = true;

    // Read the order reference from callback.
    if (event != undefined && event.reference != undefined) {
      this.orderReference = event.reference;
    }

     this.logger.write2log('processWebhookEvent', "[" + this.swrp + "] completed order. Reference: " + this.orderReference, "P");

    wrapperGtag('consent', 'update', {
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      ad_storage: 'granted',
      analytics_storage: 'granted'
    });

    try {
      var fsValue = event.subtotalInPayoutCurrency;
      this.logger.write2log('processWebhookEvent', "[" + this.swrp + "] sending data to aw: " + fsValue, "P");
      wrapperGtag('event', 'conversion', {
        'send_to': 'AW-983843646/f5bUCPnZnosBEL6GkdUD',
        'value': fsValue,
        'currency': 'USD',
        'transaction_id': event.reference
      });
    } catch (err) {
      console.log('Error saving conversion.', err);
    }

    this.logger.write2log('processWebhookEvent', "[" + this.swrp + "] start monitoring subscription status", "P");

    this.checkSubscriptionStatusInLoop();
  }

  checkSubscriptionStatusInLoop() {

    this.showWaitingForSubscription = true;
    this.showThankYouForSubscribing = false;
    this.showUpgradeOptions = false;

    // TODO UPGRADE: check for new subscription (take into account upgrades)
    var sku = this.user.getSkuToLookAfterOrderComplete();
    this.user.hasSubscriptionForSku(sku).then(
      data => {
        if (data['status'] == 1) {
          this.logger.write2log('checkSubscriptionStatusInLoop', "[" + this.swrp + "].[sku: " + sku + "]  subscription is active - got confirmation!", "P");
          this.showWaitingForSubscription = false;
          this.showThankYouForSubscribing = true;
          if (this.user.getActionAfterOrderComplete() !== this.AFTER_ORDER_COMPLETE_DO_NOTHING) {
            if (this.user.getActionAfterOrderComplete() === this.AFTER_ORDER_COMPLETE_START_ERASER_TOOL) {
              this.startUsingEraserTool();
            } else {
              this.saveAndDownload('pdf');
            }
          }
        } else {
          this.logger.write2log('checkSubscriptionStatusInLoop', "[" + this.swrp + "].[sku: " + sku + "]  subscription not active yet!", "P");
          setTimeout(this.checkSubscriptionStatusInLoop, 1000);
        }
      }
    );
  }

  closeCallback(event) {
    //$scope.$apply => { processCloseEvent(); });
    this.ngZone.run(() => { this.processCloseEvent(); });
  }
  processCloseEvent() {
    this.popupClosed = true;
    if (this.orderCompleted === true) {
      this.logger.write2log('processCloseEvent', "[" + this.swrp + "] order completed", "P");
    } else {
      this.logger.write2log('processCloseEvent', "[" + this.swrp + "] order cancelled", "P");
    }
  }

  /**
   * This will be called from the FastSpring callback when the order is completed!
   *
   */
  popupWebhookReceived() {
    console.log("Order completed!");
  }
  /**
   * This will be called from the FastSpring callback when the popup window is closed!
   */
  onPopupClosed() {
    console.log("Popup closed!");
  }

  setLogoUrl() {
    try {
      $("#van-logo").attr("href", wrapperGetLogoUrlInApp());
    } catch (e) {
    }
  }

  /**
  * Returns true/false indicating whether a dialog is shown on the page and the rest of the page should be 'inert'.
  **/
  beInert() {
    var inert = undefined;

    if (this!!.showChooseOCRLang || this!!.showSubscriptionDialog || this!!.showWaitingForSubscription || this!!.showUpgradeOptions) {
      inert = true;
    }

    if (this.navbarDiv) {
      if (inert == true && this.navbarDiv.hasAttribute("inert") == false) {
        this.navbarDiv.setAttribute("inert", "inert");
      } else if (inert == undefined && this.navbarDiv.hasAttribute("inert") == true) {
        this.navbarDiv.removeAttribute("inert");
      }
    }

    return inert;
  }
  /**
  * Handle click on the page. We show download menu when right-click is clicked.
  **/
  handlePageClick(ev) {
    try {
      if (ev !== undefined) ev.preventDefault();
      if (ev !== undefined && ev.pageX && ev.pageY) {
        this.contextualMenuStyle = { display: 'block', top: ev.pageY + 'px', left: ev.pageX + 'px' };
      } else {
        this.contextualMenuStyle = {};
      }
    } catch (e) {
      this.logger.logInternalError('PAGE: handlePageClick', e.message);
    }
  }

  handleContextualMenuClick(ev) {
    try {
      if (ev !== undefined) ev.preventDefault();
    } catch (e) {
      this.logger.logInternalError('PAGE: handlePageClick', e.message);
    }
  }
}
